import '../index.css';import { jsx as t, jsxs as D, Fragment as pe } from "react/jsx-runtime";
import { faSchoolFlag as dn } from "@fortawesome/pro-regular-svg-icons/faSchoolFlag";
import { faSuitcase as sn } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faUser as un } from "@fortawesome/pro-solid-svg-icons/faUser";
import mn from "@mui/material/Avatar";
import x from "classnames";
import We, { useState as Fe, useRef as lt, useEffect as Lt, forwardRef as Ne } from "react";
import { Typography as fn, Tooltip as gn, Box as hn, TextField as pn, MenuItem as Cn, ListItemIcon as $t, Divider as bn, Menu as yn, Popover as _n } from "@mui/material";
import { createTheme as Ln, ThemeProvider as Sn } from "@mui/material/styles";
import dt from "@mui/material/useMediaQuery";
import { faCaretDown as xn } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faArrowDownToLine as vn } from "@fortawesome/pro-regular-svg-icons/faArrowDownToLine";
import { faLoader as wn } from "@fortawesome/pro-regular-svg-icons/faLoader";
import { faLock as kn } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faPencil as Dn } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPlus as Fn } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faTrashCan as Mn } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faArrowRight as $n } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faChevronDown as In } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronRight as Bn } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { Link as et, useNavigate as Rn } from "react-router-dom";
import { dayjsLocalizer as Tn, Calendar as An } from "react-big-calendar";
import { faChevronLeft as It } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faCircleCheck as Wn } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleInfo as Nn } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faHandWave as En } from "@fortawesome/pro-solid-svg-icons/faHandWave";
import { faHourglassHalf as On } from "@fortawesome/pro-solid-svg-icons/faHourglassHalf";
import { faLightbulbOn as zn } from "@fortawesome/pro-solid-svg-icons/faLightbulbOn";
import { faLock as Hn } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faOctagonExclamation as Gn } from "@fortawesome/pro-solid-svg-icons/faOctagonExclamation";
import { faTriangleExclamation as jn } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { faXmark as Zt } from "@fortawesome/pro-regular-svg-icons/faXmark";
import { faCheck as qn } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faCircleInfo as Un } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faMinus as Yn } from "@fortawesome/pro-solid-svg-icons/faMinus";
import Xn from "@mui/material/Checkbox";
import Zn from "@mui/material/FormControlLabel";
import Kn from "@mui/material/Divider";
import { FontAwesomeIcon as Pn } from "@fortawesome/react-fontawesome";
import Vn from "@mui/material/IconButton";
import Kt from "react-spinkit";
import Jn from "@mui/material/Paper";
import Qn from "@mui/material/LinearProgress";
import eo from "@mui/material/ToggleButtonGroup";
import Bt from "@mui/material/ToggleButton";
import ue from "@mui/material/Skeleton";
import to from "@mui/material/Tabs";
import no from "@mui/material/Tab";
import { faLoader as oo } from "@fortawesome/pro-solid-svg-icons/faLoader";
import ao from "@mui/material/InputAdornment";
import { faEye as ro } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash as io } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import lo from "@mui/material/Switch";
import { faInfoCircle as co } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faCheck as so } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faAngleDown as uo } from "@fortawesome/pro-regular-svg-icons/faAngleDown";
import { faMagnifyingGlass as mo } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
const ht = {
  lg: {
    width: 48,
    height: 48,
    icon: "lg"
  },
  md: {
    width: 40,
    height: 40,
    /**
     * 'md' is not a valid size for FontAwesomeIcon.
     * When undefined is passed to FontAwesomeIcon as a size value,
     * the icon will default to the current font size of its parent element.
     */
    icon: void 0
  },
  sm: {
    width: 32,
    height: 32,
    icon: "sm"
  },
  xs: {
    width: 24,
    height: 24,
    icon: "xs"
  }
}, fo = ({
  size: e = "md",
  children: n,
  fallback: o,
  alt: a
}) => {
  var i;
  if (n)
    return n;
  const r = ((i = ht[e]) == null ? void 0 : i.icon) ?? ht.md.icon;
  switch (o) {
    case "person":
      return /* @__PURE__ */ t(
        O,
        {
          color: "inverted",
          icon: un,
          size: r,
          alt: a
        }
      );
    case "school":
      return /* @__PURE__ */ t(
        O,
        {
          color: "inverted",
          icon: dn,
          size: r,
          alt: a
        }
      );
    case "employer":
      return /* @__PURE__ */ t(
        O,
        {
          color: "inverted",
          icon: sn,
          size: r,
          alt: a
        }
      );
    default:
      return null;
  }
}, go = "_root_no82u_1", ho = "_text_no82u_5", Rt = {
  root: go,
  text: ho
}, Qd = ({
  children: e = void 0,
  fallback: n = "person",
  size: o = "md",
  ...a
}) => /* @__PURE__ */ t(
  mn,
  {
    className: x(Rt.root, { [Rt.text]: !!e }),
    sx: ht[o],
    ...a,
    children: fo({ size: o, fallback: n, children: e, alt: a.alt })
  }
), Tt = {}, po = (e) => e.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/(\d)([a-zA-Z])/g, "$1 $2").replace(/([a-zA-Z])(\d)/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(/\s+/g, "-"), es = (e) => e.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(
  /(?:\s+|^)(\w)/g,
  (n, o, a) => a === 0 ? o : o.toUpperCase()
).replace(/\s+/g, ""), Pt = (e, n = "") => typeof e == "string" ? e : ["boolean", "number"].includes(typeof e) ? String(e) : n, u = {
  white: "#FFFFFF",
  black: "#000000",
  scrim: "rgba(30, 26, 18, 0.4)",
  brand50: "#FEFEF4",
  brand100: "#FDFBD2",
  brand200: "#FBF7A5",
  brand300: "#F9F478",
  brand400: "#F9F478",
  brand500: "#F5EC1E",
  brand600: "#DCD41B",
  brand700: "#ABA515",
  brand800: "#7A7506",
  brand900: "#4A4709",
  ink50: "#F4F4F3",
  ink100: "#E8E8E7",
  ink200: "#D2D1D0",
  ink300: "#BBBAB8",
  ink400: "#A5A3A0",
  ink500: "#8E8C88",
  ink600: "#787671",
  ink700: "#625F59",
  ink800: "#4B4841",
  ink900: "#1E1A12",
  sun50: "#FFFBEB",
  sun100: "#FFF7D7",
  sun200: "#FFEFB1",
  sun300: "#FFE88A",
  sun400: "#FFDF5E",
  sun500: "#FFD52E",
  sun600: "#EDC421",
  sun700: "#BF9A08",
  sun800: "#BF9A08",
  sun900: "#8E7203",
  red50: "#FFF5F0",
  red100: "#FCE4D7",
  red200: "#FAC3AF",
  red300: "#F09785",
  red400: "#E16E63",
  red500: "#CD3535",
  red600: "#B02632",
  red700: "#931A2F",
  red800: "#76102B",
  red900: "#620A28",
  orange50: "#FFFCF2",
  orange100: "#FEF2CC",
  orange200: "#FEE29A",
  orange300: "#FECC67",
  orange400: "#FDB841",
  orange500: "#FC9603",
  orange600: "#D87702",
  orange700: "#B55C01",
  orange800: "#924400",
  orange900: "#652B00",
  green50: "#FCFFF6",
  green100: "#EEFCD4",
  green200: "#D8FAAA",
  green300: "#BAF27D",
  green400: "#9BE65B",
  green500: "#6FD62A",
  green600: "#53B81E",
  green700: "#3A9A15",
  green800: "#267C0D",
  green900: "#105D01",
  teal50: "#F3FFFE",
  teal100: "#D9FBF7",
  teal200: "#B5F8F5",
  teal300: "#8CE7EA",
  teal400: "#6ACAD6",
  teal500: "#3EA4BB",
  teal600: "#2D82A0",
  teal700: "#1F6486",
  teal800: "#13486C",
  teal900: "#0B3359",
  blue50: "#F4F9FF",
  blue100: "#D4E8FE",
  blue200: "#AACEFE",
  blue300: "#7FB1FE",
  blue400: "#5F99FE",
  blue500: "#2B70FE",
  blue600: "#1F56DA",
  blue700: "#153FB6",
  blue800: "#0D2B93",
  blue900: "#001467",
  purple50: "#FDF6FF",
  purple100: "#F8D5FF",
  purple200: "#ECABFF",
  purple300: "#DC82FF",
  purple400: "#CA63FF",
  purple500: "#AD2FFF",
  purple600: "#8722DB",
  purple700: "#6517B7",
  purple800: "#470E93",
  purple900: "#250066"
}, Co = {
  default: u.white,
  hover: u.ink50,
  pressed: u.ink100,
  selected: u.ink100,
  defaultSecondary: u.ink50,
  accentDefault: u.ink50,
  scrollbar: u.ink400,
  primaryDefault: u.blue500,
  primaryHover: u.blue400,
  primaryPressed: u.blue300,
  secondaryDefault: u.ink900,
  secondaryHover: u.ink800,
  secondaryPressed: u.ink700,
  brandDefault: u.brand500,
  brandHover: u.brand600,
  brandPressed: u.brand700,
  disabledDefault: u.ink200,
  disabledOnDisabledSurface: u.ink500,
  criticalPrimaryDefault: u.red600,
  criticalPrimaryHover: u.red700,
  criticalPrimaryPressed: u.red800,
  criticalSecondaryHover: u.red50,
  criticalSecondaryPressed: u.red100,
  statusCriticalAccent: u.red700,
  statusCriticalSubtle: u.red100,
  statusSuccessDefault: u.green800,
  statusSuccessHover: u.green700,
  statusSuccessPressed: u.green600,
  statusSuccessSubtle: u.green100,
  statusInfoDefault: u.blue600,
  statusInfoSubtle: u.blue100,
  statusInfoSubtlest: u.blue50,
  statusWarningDefault: u.orange700,
  statusWarningSubtle: u.orange100,
  statusNoteDefault: u.purple600,
  statusNoteSubtle: u.purple100,
  statusProgressDefault: u.sun900,
  statusProgressHover: u.sun800,
  statusProgressPressed: u.sun700,
  statusProgressSubtle: u.sun100
}, bo = {
  white: u.white,
  black: u.black,
  default: u.ink900,
  secondary: u.ink700,
  tertiary: u.ink500,
  inverted: u.white,
  disabledDefault: u.ink200,
  disabledOnDisabledSurface: u.ink500,
  disabledOnBrandSurface: u.brand700,
  criticalDefault: u.red500,
  criticalHover: u.red600,
  criticalPressed: u.red700,
  linkDefault: u.blue500,
  linkHover: u.blue400,
  linkPressed: u.blue700,
  statusCriticalAccent: u.red700,
  statusSuccess: u.green800,
  statusInfo: u.blue600,
  statusWarning: u.orange700,
  statusNote: u.purple600,
  statusProgress: u.sun900
}, yo = {
  default: u.ink50,
  defaultSecondary: u.ink100,
  scrim: u.scrim
}, _o = {
  default: u.ink100,
  defaultHover: u.ink500,
  defaultSelected: u.ink900,
  secondary: u.ink200,
  accent: u.ink900,
  brandDefault: u.brand600,
  brandHover: u.brand700,
  brandPressed: u.brand800,
  disabled: u.ink200,
  criticalDefault: u.red600,
  criticalHover: u.red700,
  criticalPressed: u.red800,
  statusCriticalAccent: u.red600,
  statusSuccess: u.green700,
  statusInfo: u.blue500,
  statusWarning: u.orange600,
  statusNote: u.purple600,
  statusProgress: u.sun900,
  focus: u.purple500
}, Lo = {
  critical: u.red500,
  criticalLight: u.red300,
  criticalBackground: u.red100,
  warning: u.orange500,
  warningLight: u.orange300,
  warningBackground: u.orange100,
  progress: u.sun500,
  progressLight: u.sun200,
  progressBackground: u.sun100,
  success: u.green500,
  successLight: u.green300,
  successBackground: u.green100,
  info: u.blue500,
  infoLight: u.blue300,
  infoBackground: u.blue100,
  note: u.purple500,
  noteLight: u.purple200,
  noteBackground: u.purple100,
  neutral: u.ink800,
  neutralLight: u.ink400,
  neutralBackground: u.ink100
}, be = {
  blackV2: "#1e1a12",
  font: "#363636",
  brandClever: "#4271f6",
  brandOneroster: "#0f4d87",
  blue: "#4397ea",
  blueBg: "#f5fbff",
  blueDark: "#2386e7",
  blueXtraDark: "#1477d8",
  blueContrastDark: "#124577",
  blueExtraLight: "#e6f3fa",
  blueLight: "#c4e1f2",
  blueMedium: "#68aaee",
  blueSteel: "#728dac",
  blueSteelDark: "#5f7ea0",
  blueSteelXtraDark: "#516d8f",
  blueSteelContrastDark: "#3a4e66",
  blueSteelExtraLight: "#e8eff5",
  blueSteelLight: "#cbdaeb",
  blueSteelMedium: "#8da7c4",
  gray: "#999",
  grayBg: "#f6f6f6",
  grayDark: "#6f6f6f",
  grayDarkV2: "#71726e",
  grayXtraDark: "#595959",
  grayExtraLight: "#eee",
  grayLight: "#dbdbdb",
  grayMedium: "#bebdbd",
  green: "#5aa43d",
  greenBg: "#fbfff4",
  greenDark: "#429617",
  greenXtraDark: "#268900",
  greenContrastDark: "#1c6400",
  greenExtraLight: "#f1f6e6",
  greenLight: "#ddedc9",
  greenMedium: "#7db866",
  indigo: "#7180d6",
  indigoDark: "#5d6ed0",
  indigoXtraDark: "#5364c6",
  indigoContrastDark: "#394799",
  indigoExtraLight: "#e6e9f8",
  indigoLight: "#b7c3ff",
  indigoMedium: "#8c99e3",
  orange: "#ff8000",
  orangeDark: "#f07000",
  orangeXtraDark: "#d66000",
  orangeContrastDark: "#99430d",
  orangeExtraLight: "#feedd5",
  orangeLight: "#ffd9b8",
  orangeMedium: "#fc9b5f",
  purple: "#9974dc",
  purpleDark: "#8d64d8",
  purpleXtraDark: "#8861cf",
  purpleContrastDark: "#583cbd",
  purpleExtraLight: "#ede8f8",
  purpleLight: "#d9c4ff",
  purpleMedium: "#ae8fea",
  red: "#e46658",
  redDark: "#d85446",
  redXtraDark: "#d24536",
  redContrastDark: "#9e2518",
  redExtraLight: "#ffe9e9",
  redLight: "#ffb3ab",
  redMedium: "#f67c6f",
  teal: "#16a2a2",
  tealDark: "#149090",
  tealDarkV2: "#2b7383",
  tealXtraDark: "#128484",
  tealContrastDark: "#0a5656",
  tealExtraLight: "#e3f4f2",
  tealLight: "#cceaea",
  tealLightV2: "#ecf5f7",
  tealMedium: "#62bcbc",
  violet: "#c863d9",
  violetDark: "#c253d5",
  violetXtraDark: "#ba3dd0",
  violetContrastDark: "#752383",
  violetExtraLight: "#f5e9f7",
  violetLight: "#f6c8ff",
  violetMedium: "#d68ce3",
  pink: "#d85a8c",
  pinkDark: "#cc3e76",
  pinkXtraDark: "#ba2c65",
  pinkContrastDark: "#811d45",
  pinkExtraLight: "#ffebf3",
  pinkLight: "#ffcce0",
  pinkMedium: "#fbb1cf",
  yellow: "#fad961",
  yellowV2: "#f5ec1e",
  yellowDark: "#f5c614",
  yellowXtraDark: "#eebc04",
  yellowContrastDark: "#986f15",
  yellowContrastLight: "#ffffef",
  yellowExtraLight: "#fff7da",
  yellowLight: "#ffefb7",
  yellowLightV2: "#fbfbca",
  yellowMedium: "#fbdf78",
  yellowTextDark: "#b28d02",
  ...u
}, So = {
  base: "'Bricolage Grotesque', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  baseV2: "'Bricolage Grotesque', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  body: "'Geist', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  code: "'Geist Mono', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  signature: "'Sofia', cursive",
  emoji: "emoji"
}, xo = {
  robotoLight: 300,
  robotoRegular: 400,
  robotoMedium: 500,
  robotoBold: 700,
  robotoBlack: 900,
  halisThin: 100,
  halisLight: 300,
  halisBook: 400,
  halisRegular: 500,
  halisMedium: 600,
  halisBold: 700,
  halisBlack: 800,
  thin: 100,
  extraLight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
}, K = {
  0: "0px",
  25: "2px",
  50: "4px",
  75: "6px",
  100: "8px",
  150: "12px",
  200: "16px",
  250: "20px",
  300: "24px",
  400: "32px",
  full: "999px"
}, Ke = {
  100: "0px 2px 4px 0px rgba(20, 27, 40, 0.12), 0px 1px 2px 0px rgba(20, 27, 40, 0.08)",
  200: "0px 4px 8px -2px rgba(20, 27, 40, 0.16), 0px 2px 4px -2px rgba(20, 27, 40, 0.08)",
  300: "0px 12px 16px -4px rgba(20, 27, 40, 0.16), 0px 4px 6px -2px rgba(20, 27, 40, 0.08)",
  400: "0px 16px 48px -8px rgba(20, 26, 40, 0.24)"
}, At = "74px", vo = {
  iconXxs: "10px",
  iconXs: "12px",
  iconXtSm: "14px",
  iconSm: "16px",
  iconMd: "20px",
  iconLg: "24px",
  iconXl: "32px",
  iconXxl: "40px",
  fontSizeTitleLg: "64px",
  fontSizeTitle: "26px",
  fontSizeTitleSm: "24px",
  fontSizeTitleXs: "22px",
  fontSizeLg: "20px",
  fontSizeMd: "18px",
  fontSizeSm: "16px",
  fontSizeXs: "14px",
  fontSizeXxs: "12px",
  fontSizeXxxs: "10px",
  fontSizeEmoji: "32px",
  appbarHeight: At,
  sidebarWidth: "64px",
  subnavHeight: "48px",
  containerBorderWidth: "2px",
  containerBorderRadiusLarge: K[400],
  containerBorderRadiusMedium: K[200],
  containerBorderRadius: K[100],
  containerBorderRadiusXtSmall: K[75],
  containerBorderRadiusSmall: K[50],
  containerBorderRadiusTop: `${K[100]} ${K[100]} 0 0`,
  containerBorderRadiusBottom: `0 0 ${K[100]} ${K[100]}`,
  containerBorderRadiusLeft: `${K[100]} 0 0 ${K[100]}`,
  containerBorderRadiusRight: `0 ${K[100]} ${K[100]} 0`,
  containerBorderRadiusTopLeft: `${K[100]} 0 0 0`,
  containerBorderRadiusTopRight: `0 ${K[100]} 0 0`,
  containerBorderRadiusBottomLeft: `0 0 0 ${K[100]}`,
  containerBorderRadiusBottomRight: `0 0 ${K[100]} 0`,
  contentHeight: `calc(100vh - ${At})`,
  chatBorderRadiusTopLeft: `${K[25]} ${K[200]} ${K[200]} ${K[200]}`,
  shadow: Ke[200],
  shadowTop: "0 -2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowExtraLight: "0 1px 5px rgba(0, 0, 0, 0.12)",
  shadowLight: Ke[100],
  shadowMedium: Ke[300],
  shadowStrong: Ke[400],
  shadowInset: "inset 0 0 5px 0 rgba(0, 0, 0, 0.1)",
  shadowBottom: "0px 10px 10px -6px rgba(0, 0, 0, 0.15)",
  shadowBlue: "0px 0px 0px 2px rgba(18, 69, 119, 0.40)",
  shadowGray: "0px 0px 0px 2px rgba(190, 189, 189, 0.40)",
  shadowRed: "0px 0px 0px 2px rgba(158, 37, 24, 0.40)",
  shadowFont: "0px 2px 0px 0px #363636"
}, de = {
  0: "0px",
  25: "2px",
  50: "4px",
  75: "6px",
  100: "8px",
  150: "12px",
  200: "16px",
  250: "20px",
  300: "24px",
  400: "32px",
  450: "36px",
  500: "40px",
  600: "48px",
  700: "56px",
  800: "64px",
  900: "72px",
  1e3: "80px",
  1050: "88px",
  1100: "96px",
  1150: "104px",
  1200: "112px",
  1300: "160px",
  1400: "200px",
  1500: "280px",
  1600: "360px",
  1700: "400px",
  1800: "480px",
  1900: "520px"
}, wo = {
  tt: de[0],
  tiny: de[25],
  xxs: de[50],
  xs: de[100],
  xtSm: de[100],
  input: de[100],
  sm: de[150],
  md: de[200],
  xtMd: de[300],
  lg: de[400],
  xl: de[500],
  xxl: de[600]
}, ye = {
  0: "0px",
  15: "0.6px",
  25: "1px",
  50: "2px",
  75: "4px"
}, ko = {
  defaultGray: `${ye[50]} solid ${be.gray}`,
  defaultGrayLight: `${ye[25]} solid ${be.grayLight}`,
  defaultGrayMedium: `${ye[25]} solid ${be.grayMedium}`,
  defaultGrayExtraLight: `${ye[25]} solid ${be.grayExtraLight}`,
  defaultBlue: `${ye[25]} solid ${be.blue}`,
  defaultBlueDark: `${ye[50]} solid ${be.blueDark}`,
  defaultRed: `${ye[50]} solid ${be.red}`,
  focusBlue: `${ye[50]} solid ${be.blue}`,
  white: `${ye[25]} solid ${be.white}`
}, Do = {
  widthXs: "520px",
  widthSm: "640px",
  widthMd: "760px",
  widthLg: "880px",
  widthXl: "960px"
}, Pe = {
  mobileMin: "320px",
  mobileMax: "560px",
  tabletMin: "561px",
  tabletMax: "1020px",
  desktopMin: "1021px"
}, Fo = {
  blue: "3px solid rgba(20, 119, 216, 0.75)",
  gray: "3px solid rgba(89, 89, 89, 0.75)",
  red: "3px solid rgba(210, 70, 54, 0.75)",
  green: "3px solid rgba(38, 137, 0, 0.76)"
}, s = {
  color: be,
  surface: Co,
  content: bo,
  graph: Lo,
  background: yo,
  borderColor: _o,
  fontFamily: So,
  schoolinks: vo,
  spacing: wo,
  border: ko,
  modal: Do,
  breakpoint: Pe,
  focusOutline: Fo,
  elevation: Ke,
  radius: K,
  borderWidth: ye,
  space: de,
  fontWeight: xo
}, Mo = `
/* 
* This file is auto-generated by running "yarn run build" (not "yarn run dev"). 
* Do not edit this file directly as changes will be overwritten.
* Add or update variables in src/utils/variables.js.
*/`, $o = (e) => {
  const n = [];
  for (const o in e) {
    const a = po(o), r = e[o];
    for (const i in r) {
      const c = i.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase(), l = `--${a}-${c}`, m = r[i];
      n.push(`${l}: ${m};`);
    }
  }
  return `${Mo}
:root {
${n.map((o) => `  ${o}`).join(`
`)}
}
`;
}, ts = () => {
  let e = !1;
  return {
    name: "generate-css-vars",
    apply: "build",
    config(n) {
      var o;
      (o = n.build) != null && o.watch && (e = !0);
    },
    buildStart() {
      if (e)
        return;
      console.log("Generating CSS variables...");
      const n = $o(s), o = Tt.resolve("./src/utils/variables.css");
      Tt.writeFileSync(o, n, "utf-8"), console.log(`CSS variables written to ${o}`);
    }
  };
}, Io = {
  h1: {
    fontSize: 40,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "48px"
  },
  h2: {
    fontSize: 32,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  h3: {
    fontSize: 28,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "32px"
  },
  h4: {
    fontSize: 24,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "28px"
  },
  h5: {
    fontSize: 22,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  h6: {
    fontSize: 20,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  h6Mobile: {
    fontSize: 18,
    fontFamily: s.fontFamily.base,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  lead700: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  lead500: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  lead400: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleReg700: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleReg500: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleSm700: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  titleSm500: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg700: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg600: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg500: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodyReg400: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  bodySm700: {
    fontSize: 14,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm600: {
    fontSize: 14,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm500: {
    fontSize: 14,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm400: {
    fontSize: 14,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  linkLg700: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkLg600: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkReg700: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkReg600: {
    fontSize: 16,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  linkSm700: {
    fontSize: 14,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  linkSm600: {
    fontSize: 14,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  linkXs700: {
    fontSize: 12,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  linkXs600: {
    fontSize: 12,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg700: {
    fontSize: 12,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg600: {
    fontSize: 12,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.semiBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg500: {
    fontSize: 12,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionReg400: {
    fontSize: 12,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionSm700: {
    fontSize: 10,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionSm500: {
    fontSize: 10,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.medium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  captionSm400: {
    fontSize: 10,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  stats1: {
    fontSize: 48,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "56px"
  },
  stats2: {
    fontSize: 40,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "48px"
  },
  stats3: {
    fontSize: 32,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  stats4: {
    fontSize: 28,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "32px"
  },
  stats5: {
    fontSize: 24,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "28px"
  },
  stats6: {
    fontSize: 22,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  stats7: {
    fontSize: 20,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  stats7Mobile: {
    fontSize: 18,
    fontFamily: s.fontFamily.body,
    fontWeight: s.fontWeight.bold,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  cursive: {
    fontSize: 16,
    fontFamily: s.fontFamily.signature,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  mono: {
    fontSize: 14,
    fontFamily: s.fontFamily.code,
    fontWeight: s.fontWeight.normal,
    fontStyle: "normal",
    lineHeight: "30px"
  }
}, { color: J, content: Bo } = s, Ro = Ln({
  typography: Io,
  palette: {
    primary: {
      main: J.blue,
      light: J.blue,
      dark: J.blueDark,
      contrastText: J.white
    },
    secondary: {
      main: J.blue,
      light: J.blue,
      dark: J.blueDark,
      contrastText: J.white
    },
    action: {
      hover: J.blueExtraLight,
      selected: J.blueExtraLight
    },
    error: {
      main: Bo.criticalDefault
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      // mobile
      md: 561,
      // tablet
      lg: 1021,
      // desktop
      xl: 1600
    }
  },
  components: {
    // Customization
    /*
      Body font properties updated to v4 to prevent UI bugs.
      Related documentation.
      https://mui.com/guides/migration-v4/#cssbaseline
    */
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: "1.43",
          letterSpacing: "0.01071em"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "linear-gradient(0deg, rgba(2, 136, 209, 0.15), rgba(2, 136, 209, 0.15)), var(--color-white)"
        },
        icon: {
          marginRight: 4
        },
        deleteIcon: {
          marginLeft: 4
        },
        colorPrimary: {
          backgroundColor: J.blueExtraLight,
          color: J.font,
          "& > svg": {
            color: J.font
          }
        },
        deleteIconColorPrimary: {
          "&:hover": {
            color: J.font
          }
        },
        deletableColorPrimary: {
          "&:focus": {
            backgroundColor: J.blueDark
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: 11,
          paddingBottom: 11
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: 1400
          // has to be bigger than the MuiModal zIndex
        }
      }
    },
    // existing overrides
    MuiModal: {
      styleOverrides: {
        root: {
          // lowered from 1350 to 1300 so we can see date pickers in modals
          zIndex: 1300
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        maxWidth: !1
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: 1300
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&$selected": {
            backgroundColor: "rgba(2,136,209,0.05)"
          },
          "&$hover:hover": {
            backgroundColor: "rgba(2,136,209,0.05)"
          }
        }
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (e) => e === "next" ? "Next Page" : e === "previous" ? "Previous Page" : ""
      },
      styleOverrides: {
        selectLabel: {
          margin: 0
        },
        displayedRows: {
          margin: 0
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#bbb !important",
          "&$active": {
            color: `${J.blue} !important`
          },
          "&$completed": {
            color: `${J.blue} !important`
          }
        },
        active: {},
        completed: {}
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: void 0
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "& > .textLink, & > .textLinkButton": {
            textDecoration: "underline"
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          "& .PrivatePickersYear-yearButton": {
            fontFamily: "Geist, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
        }
      }
    },
    PrivatePickersYear: {
      styleOverrides: {
        yearButton: {
          fontFamily: "Geist, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    }
  }
}), To = s.content.default, Wt = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g, Ao = () => {
  const e = {
    content: s.content,
    surface: s.surface,
    graph: s.graph,
    background: s.background
  }, n = {};
  for (const o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      const a = e[o];
      for (const r in a)
        if (Object.prototype.hasOwnProperty.call(a, r)) {
          const i = r.charAt(0).toUpperCase() + r.slice(1);
          n[`${o}${i}`] = a[r];
        }
    }
  return n;
}, ct = (e = "", n = "") => {
  const o = Ao(), a = {
    ...s.color,
    ...s.content,
    // For backward compatibility with unprefixed content colors like 'default'
    ...o
  };
  return e in a ? (console.log({ color: e, allColors: a }), a[e]) : Wt.test(e) ? (console.log({ color: e, test: Wt.test(e) }), e) : (e && console.warn(`Wrong color name '${e}' provided, using fallback color.`), n || To);
};
var F = /* @__PURE__ */ ((e) => (e.h1 = "h1", e.h2 = "h2", e.h3 = "h3", e.h4 = "h4", e.h5 = "h5", e.h6 = "h6", e.h6Mobile = "h6Mobile", e.lead700 = "lead700", e.lead500 = "lead500", e.lead400 = "lead400", e.titleReg700 = "titleReg700", e.titleReg500 = "titleReg500", e.titleSm700 = "titleSm700", e.titleSm500 = "titleSm500", e.bodyReg700 = "bodyReg700", e.bodyReg600 = "bodyReg600", e.bodyReg500 = "bodyReg500", e.bodyReg400 = "bodyReg400", e.bodySm700 = "bodySm700", e.bodySm600 = "bodySm600", e.bodySm500 = "bodySm500", e.bodySm400 = "bodySm400", e.linkLg700 = "linkLg700", e.linkLg600 = "linkLg600", e.linkReg700 = "linkReg700", e.linkReg600 = "linkReg600", e.linkSm700 = "linkSm700", e.linkSm600 = "linkSm600", e.linkXs700 = "linkXs700", e.linkXs600 = "linkXs600", e.captionReg700 = "captionReg700", e.captionReg600 = "captionReg600", e.captionReg500 = "captionReg500", e.captionReg400 = "captionReg400", e.captionSm700 = "captionSm700", e.captionSm500 = "captionSm500", e.captionSm400 = "captionSm400", e.stats1 = "stats1", e.stats2 = "stats2", e.stats3 = "stats3", e.stats4 = "stats4", e.stats5 = "stats5", e.stats6 = "stats6", e.stats7 = "stats7", e.stats7Mobile = "stats7Mobile", e.mono = "mono", e.cursive = "cursive", e))(F || {});
const Nt = {
  h1: F.h2,
  h2: F.h3,
  h3: F.h4,
  h4: F.h5,
  h5: F.h6,
  h6: F.h6Mobile,
  stats1: F.stats2,
  stats2: F.stats3,
  stats3: F.stats4,
  stats4: F.stats5,
  stats5: F.stats6,
  stats6: F.stats7,
  stats7: F.stats7Mobile
}, Et = {
  lead: F.lead400,
  leadBold: F.lead700,
  titleMd: F.titleReg500,
  titleMd500: F.titleReg500,
  titleMd700: F.titleReg700,
  titleMdBold: F.titleReg700,
  titleSm: F.titleSm500,
  titleSmBold: F.titleSm700,
  bodyMd400: F.bodyReg400,
  bodyMd500: F.bodyReg500,
  bodyMd600: F.bodyReg600,
  bodyMd700: F.bodyReg700,
  bodyMd: F.bodyReg400,
  bodyMdBold: F.bodyReg700,
  bodySm400: F.bodySm400,
  bodySm500: F.bodySm500,
  bodySm600: F.bodySm600,
  bodySm700: F.bodySm700,
  bodySm: F.bodySm400,
  bodySmBold: F.bodySm700,
  meta: F.captionReg400,
  meta400: F.captionReg400,
  meta700: F.captionReg700,
  metaBold: F.captionReg700,
  body1: F.bodyReg400,
  body2: F.bodySm400,
  subtitle1: F.titleReg500,
  subtitle2: F.titleSm500,
  caption: F.captionReg400,
  label: F.captionReg500,
  tiny: F.captionSm500,
  overline: F.captionSm500,
  button: F.bodyReg400
}, Wo = (e) => typeof e == "string" && document.createElement(e) instanceof HTMLUnknownElement ? "p" : e, No = (e, n) => {
  const o = Object.keys(Et);
  return e in F ? n && Nt[e] ? Nt[e] : e : o.includes(e) ? Et[e] : F.bodyReg500;
}, Eo = {
  mobile: `(max-width: ${Pe.mobileMax})`,
  tablet: `(min-width: ${Pe.tabletMin}) and (max-width: ${Pe.tabletMax})`,
  desktop: `(min-width: ${Pe.desktopMin})`
}, St = (e = Eo) => {
  const n = dt(e.mobile), o = dt(e.tablet), a = dt(e.desktop);
  return { isMobile: n, isTablet: o, isDesktop: a };
}, Oo = "_italic_kwzg6_8", zo = "_bold_kwzg6_12", Ho = "_underlined_kwzg6_16", st = {
  italic: Oo,
  bold: zo,
  underlined: Ho
}, G = We.forwardRef(
  ({
    className: e,
    color: n,
    component: o = "p",
    isBold: a,
    isItalic: r,
    isUnderlined: i,
    testId: c,
    variant: l = "bodyReg500",
    ...m
  }, d) => {
    const { isMobile: h } = St(), b = No(l, h);
    return /* @__PURE__ */ t(
      fn,
      {
        ref: d,
        "data-testid": c,
        sx: { color: ct(n) },
        className: x(e, {
          [st.italic]: r,
          [st.bold]: a,
          [st.underlined]: i
        }),
        variant: b,
        component: Wo(o),
        ...m
      }
    );
  }
);
var Q = /* @__PURE__ */ ((e) => (e.Critical = "critical", e.Neutral = "neutral", e.Warning = "warning", e.Success = "success", e.Info = "info", e.Note = "note", e.Progress = "progress", e.Disabled = "disabled", e))(Q || {});
const Vt = (e) => Object.values(Q).includes(
  e
) ? e : {
  blue: Q.Info,
  "blue-steel": Q.Info,
  gray: Q.Neutral,
  green: Q.Success,
  orange: Q.Warning,
  red: Q.Critical,
  teal: Q.Info,
  yellow: Q.Progress,
  disabled: Q.Disabled
}[e] || Q.Success, Go = "_badgeContainer_mxw9r_3", jo = "_label_mxw9r_9", qo = "_large_mxw9r_17", Uo = "_badge_mxw9r_3", Yo = "_small_mxw9r_28", Xo = "_neutral_mxw9r_45", Zo = "_warning_mxw9r_46", Ko = "_progress_mxw9r_47", Po = "_critical_mxw9r_48", Vo = "_info_mxw9r_49", Jo = "_success_mxw9r_50", Qo = "_note_mxw9r_51", ea = "_outlined_mxw9r_60", ta = "_text_mxw9r_66", na = "_disabled_mxw9r_155", oa = "_transparent_mxw9r_173", Ce = {
  badgeContainer: Go,
  label: jo,
  large: qo,
  badge: Uo,
  small: Yo,
  default: "_default_mxw9r_34",
  neutral: Xo,
  warning: Zo,
  progress: Ko,
  critical: Po,
  info: Vo,
  success: Jo,
  note: Qo,
  outlined: ea,
  text: ta,
  disabled: na,
  transparent: oa
}, Ye = ({
  label: e,
  style: n,
  classes: o,
  number: a = 0,
  color: r = Q.Neutral,
  size: i = "default",
  variant: c = "filled",
  disableEmpty: l = !0,
  isDisabled: m = !1,
  badgeClassName: d
}) => {
  const h = c === "filled", b = c === "outlined", y = c === "text", p = Vt(r), g = Ce[p], f = () => i === "small" ? "captionSm700" : i === "large" ? "bodySm700" : "captionReg700";
  return /* @__PURE__ */ D("div", { style: n, className: x(Ce.badgeContainer, o == null ? void 0 : o.root), children: [
    /* @__PURE__ */ t(
      "div",
      {
        "data-testid": "badgeNumberContainer",
        className: x(
          Ce.badge,
          g,
          Ce[i],
          {
            [Ce.transparent]: !h,
            [Ce.disabled]: m || r === "disabled" || l && !a,
            [Ce.outlined]: b,
            [Ce.text]: y
          },
          d
        ),
        children: /* @__PURE__ */ t(G, { "data-testid": "badgeNumber", variant: f(), children: a })
      }
    ),
    e ? /* @__PURE__ */ t("div", { "data-testid": "badgeLabel", className: x(Ce.label, Ce[i]), children: e }) : null
  ] });
};
var te = /* @__PURE__ */ ((e) => (e.Default = "default", e.Secondary = "secondary", e.Critical = "critical", e))(te || {}), Me = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e.Default = "default", e))(Me || {}), _e = /* @__PURE__ */ ((e) => (e.Text = "text", e.Filled = "filled", e.Outlined = "outlined", e))(_e || {});
const aa = "_button_17a5q_1", ra = "_compactButton_17a5q_2", ia = "_disabled_17a5q_20", la = "_loading_17a5q_57", ca = "_badge_17a5q_63", da = "_withWhiteBackground_17a5q_275", sa = "_badgeContainer_17a5q_293", ua = "_compactLabel_17a5q_335", ma = "_shadowButton_17a5q_340", fa = "_outlined_17a5q_482", ga = "_rightIcon_17a5q_486", ha = "_icon_17a5q_490", pa = "_noLabel_17a5q_491", Ca = "_noLabelContainer_17a5q_513", ba = "_label_17a5q_517", ya = "_confirmationPopoverPaper_17a5q_536", _a = "_maxWidth_17a5q_541", E = {
  button: aa,
  compactButton: ra,
  disabled: ia,
  "size-small": "_size-small_17a5q_24",
  "size-default": "_size-default_17a5q_25",
  "size-medium": "_size-medium_17a5q_32",
  "size-large": "_size-large_17a5q_33",
  "color-default": "_color-default_17a5q_56",
  loading: la,
  badge: ca,
  "color-secondary": "_color-secondary_17a5q_76",
  "color-critical": "_color-critical_17a5q_96",
  "variant-filled": "_variant-filled_17a5q_116",
  "variant-outlined": "_variant-outlined_17a5q_179",
  "variant-text": "_variant-text_17a5q_228",
  withWhiteBackground: da,
  badgeContainer: sa,
  "text-color-default": "_text-color-default_17a5q_299",
  "text-color-secondary": "_text-color-secondary_17a5q_303",
  "text-color-critical": "_text-color-critical_17a5q_307",
  compactLabel: ua,
  shadowButton: ma,
  outlined: fa,
  rightIcon: ga,
  icon: ha,
  noLabel: pa,
  noLabelContainer: Ca,
  label: ba,
  confirmationPopoverPaper: ya,
  maxWidth: _a
}, La = ({
  badgeCount: e,
  color: n,
  component: o,
  handleClick: a,
  hasIconLeft: r,
  hasIconRight: i,
  hasNoWrap: c,
  hasWhiteBackground: l,
  iconToRender: m,
  isLoading: d,
  label: h,
  showBadge: b,
  size: y = Me.Default,
  tooltipProps: p,
  variant: g = _e.Text,
  ...f
}) => {
  const [v, S] = Fe(void 0), B = lt(null);
  return Lt(() => {
    B.current && !d && h && S(B.current.getBoundingClientRect().width);
  }, [d, h]), /* @__PURE__ */ t(fe, { title: (p == null ? void 0 : p.title) ?? "", ...p, children: /* @__PURE__ */ D(
    o,
    {
      "data-testid": "base-button",
      ref: B,
      ...f,
      className: x(
        f.className,
        E.button,
        E[`size-${y}`],
        E[`color-${n}`],
        E[`variant-${g}`],
        {
          [E.disabled]: f.disabled,
          [E.loading]: d,
          [E.withWhiteBackground]: l
        }
      ),
      style: {
        whiteSpace: c ? "nowrap" : void 0,
        minWidth: d && v ? `${v}px` : void 0,
        ...f.style
      },
      onClick: a,
      children: [
        (r || d) && m,
        !!h && /* @__PURE__ */ t("span", { children: h }),
        i && !d && m,
        b && /* @__PURE__ */ t(
          Ye,
          {
            color: "neutral",
            number: e ?? 0,
            classes: { root: E.badgeContainer },
            badgeClassName: E.badge
          }
        )
      ]
    }
  ) });
}, Sa = ({
  badgeCount: e,
  color: n,
  component: o,
  handleClick: a,
  hasNoWrap: r,
  hasWhiteBackground: i,
  iconToRender: c,
  innerLabel: l,
  isCompactSelect: m,
  isLoading: d,
  label: h,
  size: b = Me.Default,
  showBadge: y,
  textVariant: p,
  tooltipProps: g,
  variant: f = _e.Text,
  ...v
}) => /* @__PURE__ */ t(fe, { title: (g == null ? void 0 : g.title) ?? "", ...g, children: /* @__PURE__ */ D(W, { flexDirection: "column", alignItems: "center", width: "fit-content", children: [
  /* @__PURE__ */ D(
    o,
    {
      "data-testid": "compact-button",
      ...v,
      className: x(
        E.compactButton,
        v.className,
        E[`size-${b}`],
        E[`color-${n}`],
        E[`variant-${f}`],
        {
          [E.disabled]: v.disabled,
          [E.loading]: d,
          [E.withWhiteBackground]: i
        }
      ),
      style: {
        whiteSpace: r ? "nowrap" : void 0,
        ...v.style
      },
      onClick: a,
      children: [
        l && /* @__PURE__ */ t(
          G,
          {
            color: f === "filled" ? "white" : void 0,
            className: f === "filled" ? void 0 : E[`text-color-${n}`],
            variant: p,
            children: l
          }
        ),
        c,
        m && /* @__PURE__ */ t(O, { icon: xn }),
        y && /* @__PURE__ */ t(
          Ye,
          {
            number: e ?? 0,
            color: Q.Neutral,
            classes: { root: E.badgeContainer },
            badgeClassName: E.badge
          }
        )
      ]
    }
  ),
  h && /* @__PURE__ */ t(
    G,
    {
      className: x(E.compactLabel, E[`text-color-${n}`]),
      variant: "captionReg500",
      mt: 0.5,
      children: h
    }
  )
] }) }), xa = ({ title: e }) => typeof e == "string" ? /* @__PURE__ */ t(pe, { children: e }) : e, va = "_tooltip_fry87_3", wa = "_arrow_fry87_13", Ot = {
  tooltip: va,
  arrow: wa
}, fe = ({
  title: e = "",
  arrow: n = !0,
  tooltipClass: o = "",
  children: a,
  ...r
}) => {
  const { classes: i = {} } = r;
  return /* @__PURE__ */ t(
    gn,
    {
      ...r,
      classes: {
        ...i,
        tooltip: x(Ot.tooltip, o),
        arrow: Ot.arrow
      },
      title: e || e === 0 ? /* @__PURE__ */ t(xa, { title: e }) : "",
      enterTouchDelay: 0,
      arrow: n,
      children: a
    }
  );
}, ka = ({
  classes: e,
  color: n = te.Default,
  component: o,
  handleClick: a,
  hasIconRight: r,
  iconToRender: i,
  isLoading: c,
  label: l,
  size: m = Me.Large,
  tooltipProps: d,
  variant: h = _e.Outlined,
  ...b
}) => /* @__PURE__ */ t(fe, { title: (d == null ? void 0 : d.title) ?? "", ...d, children: /* @__PURE__ */ D(
  o,
  {
    "data-testid": "shadow-button",
    ...b,
    className: x(
      E.shadowButton,
      E[`color-${n}`],
      E[`size-${m}`],
      E[`variant-${h}`],
      {
        [E.rightIcon]: r,
        [E.disabled]: b.disabled,
        [E.noLabelContainer]: !l,
        [E.loading]: c
      },
      b.className
    ),
    onClick: a,
    children: [
      i ? /* @__PURE__ */ t("span", { className: x(E.icon, { [E.noLabel]: !l }, e == null ? void 0 : e.icon), children: i }) : null,
      l ? /* @__PURE__ */ t("span", { className: x(E.label, e == null ? void 0 : e.label), children: l }) : null
    ]
  }
) }), Ge = (e) => /^http(s)?:\/\//.test(e) || /mailto:([^?]*)/.test(e), rt = ({
  badgeCount: e,
  children: n,
  classes: o,
  color: a = te.Default,
  compactVariant: r,
  confirmationPopoverProps: i,
  hasIconLeft: c,
  hasIconRight: l,
  hasNoWrap: m,
  hasWhiteBackground: d,
  href: h,
  icon: b,
  innerLabel: y,
  isLoading: p,
  label: g,
  newTab: f,
  size: v = Me.Default,
  textVariant: S,
  tooltipProps: B,
  variant: $,
  withShadow: N,
  ...M
}) => {
  const z = r === "select", U = r === "default", X = $ === _e.Outlined, H = $ === _e.Filled, I = !!e && (X || U), ce = d !== void 0 ? d : X, {
    confirmationOpenColor: Le,
    confirmationButtonColor: k,
    confirmationText: _,
    confirmationPopover: C,
    confirmationButtonText: w,
    confirmationPopoverCancelButtonText: L,
    confirmationContent: T,
    placement: A,
    hideArrow: j,
    menuClasses: Y,
    menuProps: P,
    wrapperClass: V,
    paperClass: oe,
    anchorButtonClass: $e,
    onCloseCallback: Se
  } = i ?? {}, Ie = {
    blue: te.Default,
    gray: te.Secondary,
    red: te.Critical
  }, xe = {
    [te.Default]: "primaryDefault",
    [te.Secondary]: "secondaryDefault",
    [te.Critical]: "criticalPrimaryDefault"
  }, Z = () => H ? "white" : xe[a] ?? "primaryDefault", ge = {
    arrow: /* @__PURE__ */ t(
      O,
      {
        color: Z(),
        rotation: c ? 180 : void 0,
        icon: $n
      }
    ),
    chevron: /* @__PURE__ */ t(
      O,
      {
        color: Z(),
        icon: l || c ? Bn : In,
        rotation: c ? 180 : void 0
      }
    ),
    edit: /* @__PURE__ */ t(
      O,
      {
        color: Z(),
        "data-testid": "edit-icon",
        icon: Dn
      }
    ),
    plus: /* @__PURE__ */ t(O, { color: Z(), icon: Fn }),
    trash: /* @__PURE__ */ t(O, { color: Z(), icon: Mn }),
    lock: /* @__PURE__ */ t(O, { color: Z(), icon: kn }),
    download: /* @__PURE__ */ t(O, { color: Z(), icon: vn })
  }, Ee = p ? /* @__PURE__ */ t(O, { "data-testid": "loader-icon", icon: wn, spin: !0 }) : Object.keys(ge).includes(b) ? ge[b] : b, kt = (ee, he) => {
    var Be;
    if (!(p || M.disabled)) {
      if (_ || C) {
        he == null || he();
        return;
      }
      (Be = M.onClick) == null || Be.call(M, ee);
    }
  }, Dt = (() => {
    if (!h || M.disabled)
      return {
        component: "button",
        to: "",
        type: M.type ?? "button"
      };
    const ee = f || Ge(h) ? { target: "_blank", rel: "noopener noreferrer" } : {};
    return Ge(h) ? { component: "a", to: "", href: h, ...ee } : { component: et, to: h, ...ee };
  })(), Ft = Object.values(te).includes(a) ? a : Ie[a] ? Ie[a] : te.Default, Mt = ({
    anchorElementProps: ee
  } = {}) => {
    if (N)
      return /* @__PURE__ */ t(
        ka,
        {
          "aria-label": M["aria-label"] ?? g,
          classes: o,
          color: Le ?? Ft,
          disabled: M.disabled || p,
          handleClick: kt,
          hasIconLeft: c,
          hasIconRight: l,
          iconToRender: Ee,
          isLoading: p,
          label: p ? void 0 : g,
          size: v,
          tooltipProps: B,
          variant: $,
          ...M,
          ...Dt
        }
      );
    const he = {
      "aria-label": M["aria-label"] ?? g,
      badgeCount: e,
      color: Le ?? Ft,
      disabled: M.disabled || p,
      handleClick: (Be) => kt(
        Be,
        ee != null && ee.onClick ? () => ee.onClick(
          Be
        ) : void 0
      ),
      hasNoWrap: m,
      hasWhiteBackground: ce,
      iconToRender: Ee,
      isLoading: p,
      showBadge: I,
      tooltipProps: B,
      size: v,
      variant: $,
      ...M,
      ...Dt
    };
    return z || U ? /* @__PURE__ */ t(
      Sa,
      {
        isCompactSelect: z,
        innerLabel: y,
        label: g,
        textVariant: S,
        ...he
      }
    ) : /* @__PURE__ */ t(
      La,
      {
        hasIconLeft: c,
        hasIconRight: l,
        label: p ? "" : g,
        ...he
      }
    );
  };
  return i ? /* @__PURE__ */ t(
    wt,
    {
      paperClass: x(E.confirmationPopoverPaper, oe, {
        [E.maxWidth]: !C
      }),
      withCustomAnchor: !0,
      anchorContent: ({
        anchorElementProps: ee
      }) => Mt({ anchorElementProps: ee }),
      popoverContent: ({ setAnchor: ee }) => C ? C({
        closePopover: () => ee(null)
      }) : /* @__PURE__ */ D("div", { children: [
        _ && /* @__PURE__ */ t(G, { variant: "bodySm400", mb: 1.5, children: _ }),
        T,
        /* @__PURE__ */ D(
          W,
          {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ t(
                rt,
                {
                  label: L ?? "Cancel",
                  size: Me.Small,
                  color: te.Default,
                  variant: _e.Text,
                  onClick: (he) => {
                    he.stopPropagation(), ee(null);
                  }
                }
              ),
              /* @__PURE__ */ t(
                rt,
                {
                  label: w ?? "Delete",
                  size: Me.Small,
                  variant: _e.Outlined,
                  color: k ?? te.Critical,
                  onClick: (he) => {
                    var Be;
                    he.stopPropagation(), (Be = M.onClick) == null || Be.call(M, he), ee(null);
                  }
                }
              )
            ]
          }
        )
      ] }),
      placement: A,
      hideArrow: j,
      tooltipProps: i == null ? void 0 : i.tooltipProps,
      menuProps: P,
      wrapperClass: V,
      menuClasses: Y,
      anchorButtonClass: $e,
      onCloseCallback: Se
    }
  ) : Mt();
};
function Da(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var at = { exports: {} }, Fa = at.exports, zt;
function Ma() {
  return zt || (zt = 1, function(e, n) {
    (function(o, a) {
      e.exports = a();
    })(Fa, function() {
      var o = 1e3, a = 6e4, r = 36e5, i = "millisecond", c = "second", l = "minute", m = "hour", d = "day", h = "week", b = "month", y = "quarter", p = "year", g = "date", f = "Invalid Date", v = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, S = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, B = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(k) {
        var _ = ["th", "st", "nd", "rd"], C = k % 100;
        return "[" + k + (_[(C - 20) % 10] || _[C] || _[0]) + "]";
      } }, $ = function(k, _, C) {
        var w = String(k);
        return !w || w.length >= _ ? k : "" + Array(_ + 1 - w.length).join(C) + k;
      }, N = { s: $, z: function(k) {
        var _ = -k.utcOffset(), C = Math.abs(_), w = Math.floor(C / 60), L = C % 60;
        return (_ <= 0 ? "+" : "-") + $(w, 2, "0") + ":" + $(L, 2, "0");
      }, m: function k(_, C) {
        if (_.date() < C.date()) return -k(C, _);
        var w = 12 * (C.year() - _.year()) + (C.month() - _.month()), L = _.clone().add(w, b), T = C - L < 0, A = _.clone().add(w + (T ? -1 : 1), b);
        return +(-(w + (C - L) / (T ? L - A : A - L)) || 0);
      }, a: function(k) {
        return k < 0 ? Math.ceil(k) || 0 : Math.floor(k);
      }, p: function(k) {
        return { M: b, y: p, w: h, d, D: g, h: m, m: l, s: c, ms: i, Q: y }[k] || String(k || "").toLowerCase().replace(/s$/, "");
      }, u: function(k) {
        return k === void 0;
      } }, M = "en", z = {};
      z[M] = B;
      var U = "$isDayjsObject", X = function(k) {
        return k instanceof ce || !(!k || !k[U]);
      }, H = function k(_, C, w) {
        var L;
        if (!_) return M;
        if (typeof _ == "string") {
          var T = _.toLowerCase();
          z[T] && (L = T), C && (z[T] = C, L = T);
          var A = _.split("-");
          if (!L && A.length > 1) return k(A[0]);
        } else {
          var j = _.name;
          z[j] = _, L = j;
        }
        return !w && L && (M = L), L || !w && M;
      }, R = function(k, _) {
        if (X(k)) return k.clone();
        var C = typeof _ == "object" ? _ : {};
        return C.date = k, C.args = arguments, new ce(C);
      }, I = N;
      I.l = H, I.i = X, I.w = function(k, _) {
        return R(k, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
      };
      var ce = function() {
        function k(C) {
          this.$L = H(C.locale, null, !0), this.parse(C), this.$x = this.$x || C.x || {}, this[U] = !0;
        }
        var _ = k.prototype;
        return _.parse = function(C) {
          this.$d = function(w) {
            var L = w.date, T = w.utc;
            if (L === null) return /* @__PURE__ */ new Date(NaN);
            if (I.u(L)) return /* @__PURE__ */ new Date();
            if (L instanceof Date) return new Date(L);
            if (typeof L == "string" && !/Z$/i.test(L)) {
              var A = L.match(v);
              if (A) {
                var j = A[2] - 1 || 0, Y = (A[7] || "0").substring(0, 3);
                return T ? new Date(Date.UTC(A[1], j, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, Y)) : new Date(A[1], j, A[3] || 1, A[4] || 0, A[5] || 0, A[6] || 0, Y);
              }
            }
            return new Date(L);
          }(C), this.init();
        }, _.init = function() {
          var C = this.$d;
          this.$y = C.getFullYear(), this.$M = C.getMonth(), this.$D = C.getDate(), this.$W = C.getDay(), this.$H = C.getHours(), this.$m = C.getMinutes(), this.$s = C.getSeconds(), this.$ms = C.getMilliseconds();
        }, _.$utils = function() {
          return I;
        }, _.isValid = function() {
          return this.$d.toString() !== f;
        }, _.isSame = function(C, w) {
          var L = R(C);
          return this.startOf(w) <= L && L <= this.endOf(w);
        }, _.isAfter = function(C, w) {
          return R(C) < this.startOf(w);
        }, _.isBefore = function(C, w) {
          return this.endOf(w) < R(C);
        }, _.$g = function(C, w, L) {
          return I.u(C) ? this[w] : this.set(L, C);
        }, _.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, _.valueOf = function() {
          return this.$d.getTime();
        }, _.startOf = function(C, w) {
          var L = this, T = !!I.u(w) || w, A = I.p(C), j = function(xe, Z) {
            var ge = I.w(L.$u ? Date.UTC(L.$y, Z, xe) : new Date(L.$y, Z, xe), L);
            return T ? ge : ge.endOf(d);
          }, Y = function(xe, Z) {
            return I.w(L.toDate()[xe].apply(L.toDate("s"), (T ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), L);
          }, P = this.$W, V = this.$M, oe = this.$D, $e = "set" + (this.$u ? "UTC" : "");
          switch (A) {
            case p:
              return T ? j(1, 0) : j(31, 11);
            case b:
              return T ? j(1, V) : j(0, V + 1);
            case h:
              var Se = this.$locale().weekStart || 0, Ie = (P < Se ? P + 7 : P) - Se;
              return j(T ? oe - Ie : oe + (6 - Ie), V);
            case d:
            case g:
              return Y($e + "Hours", 0);
            case m:
              return Y($e + "Minutes", 1);
            case l:
              return Y($e + "Seconds", 2);
            case c:
              return Y($e + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, _.endOf = function(C) {
          return this.startOf(C, !1);
        }, _.$set = function(C, w) {
          var L, T = I.p(C), A = "set" + (this.$u ? "UTC" : ""), j = (L = {}, L[d] = A + "Date", L[g] = A + "Date", L[b] = A + "Month", L[p] = A + "FullYear", L[m] = A + "Hours", L[l] = A + "Minutes", L[c] = A + "Seconds", L[i] = A + "Milliseconds", L)[T], Y = T === d ? this.$D + (w - this.$W) : w;
          if (T === b || T === p) {
            var P = this.clone().set(g, 1);
            P.$d[j](Y), P.init(), this.$d = P.set(g, Math.min(this.$D, P.daysInMonth())).$d;
          } else j && this.$d[j](Y);
          return this.init(), this;
        }, _.set = function(C, w) {
          return this.clone().$set(C, w);
        }, _.get = function(C) {
          return this[I.p(C)]();
        }, _.add = function(C, w) {
          var L, T = this;
          C = Number(C);
          var A = I.p(w), j = function(V) {
            var oe = R(T);
            return I.w(oe.date(oe.date() + Math.round(V * C)), T);
          };
          if (A === b) return this.set(b, this.$M + C);
          if (A === p) return this.set(p, this.$y + C);
          if (A === d) return j(1);
          if (A === h) return j(7);
          var Y = (L = {}, L[l] = a, L[m] = r, L[c] = o, L)[A] || 1, P = this.$d.getTime() + C * Y;
          return I.w(P, this);
        }, _.subtract = function(C, w) {
          return this.add(-1 * C, w);
        }, _.format = function(C) {
          var w = this, L = this.$locale();
          if (!this.isValid()) return L.invalidDate || f;
          var T = C || "YYYY-MM-DDTHH:mm:ssZ", A = I.z(this), j = this.$H, Y = this.$m, P = this.$M, V = L.weekdays, oe = L.months, $e = L.meridiem, Se = function(Z, ge, je, Ee) {
            return Z && (Z[ge] || Z(w, T)) || je[ge].slice(0, Ee);
          }, Ie = function(Z) {
            return I.s(j % 12 || 12, Z, "0");
          }, xe = $e || function(Z, ge, je) {
            var Ee = Z < 12 ? "AM" : "PM";
            return je ? Ee.toLowerCase() : Ee;
          };
          return T.replace(S, function(Z, ge) {
            return ge || function(je) {
              switch (je) {
                case "YY":
                  return String(w.$y).slice(-2);
                case "YYYY":
                  return I.s(w.$y, 4, "0");
                case "M":
                  return P + 1;
                case "MM":
                  return I.s(P + 1, 2, "0");
                case "MMM":
                  return Se(L.monthsShort, P, oe, 3);
                case "MMMM":
                  return Se(oe, P);
                case "D":
                  return w.$D;
                case "DD":
                  return I.s(w.$D, 2, "0");
                case "d":
                  return String(w.$W);
                case "dd":
                  return Se(L.weekdaysMin, w.$W, V, 2);
                case "ddd":
                  return Se(L.weekdaysShort, w.$W, V, 3);
                case "dddd":
                  return V[w.$W];
                case "H":
                  return String(j);
                case "HH":
                  return I.s(j, 2, "0");
                case "h":
                  return Ie(1);
                case "hh":
                  return Ie(2);
                case "a":
                  return xe(j, Y, !0);
                case "A":
                  return xe(j, Y, !1);
                case "m":
                  return String(Y);
                case "mm":
                  return I.s(Y, 2, "0");
                case "s":
                  return String(w.$s);
                case "ss":
                  return I.s(w.$s, 2, "0");
                case "SSS":
                  return I.s(w.$ms, 3, "0");
                case "Z":
                  return A;
              }
              return null;
            }(Z) || A.replace(":", "");
          });
        }, _.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, _.diff = function(C, w, L) {
          var T, A = this, j = I.p(w), Y = R(C), P = (Y.utcOffset() - this.utcOffset()) * a, V = this - Y, oe = function() {
            return I.m(A, Y);
          };
          switch (j) {
            case p:
              T = oe() / 12;
              break;
            case b:
              T = oe();
              break;
            case y:
              T = oe() / 3;
              break;
            case h:
              T = (V - P) / 6048e5;
              break;
            case d:
              T = (V - P) / 864e5;
              break;
            case m:
              T = V / r;
              break;
            case l:
              T = V / a;
              break;
            case c:
              T = V / o;
              break;
            default:
              T = V;
          }
          return L ? T : I.a(T);
        }, _.daysInMonth = function() {
          return this.endOf(b).$D;
        }, _.$locale = function() {
          return z[this.$L];
        }, _.locale = function(C, w) {
          if (!C) return this.$L;
          var L = this.clone(), T = H(C, w, !0);
          return T && (L.$L = T), L;
        }, _.clone = function() {
          return I.w(this.$d, this);
        }, _.toDate = function() {
          return new Date(this.valueOf());
        }, _.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, _.toISOString = function() {
          return this.$d.toISOString();
        }, _.toString = function() {
          return this.$d.toUTCString();
        }, k;
      }(), Le = ce.prototype;
      return R.prototype = Le, [["$ms", i], ["$s", c], ["$m", l], ["$H", m], ["$W", d], ["$M", b], ["$y", p], ["$D", g]].forEach(function(k) {
        Le[k[1]] = function(_) {
          return this.$g(_, k[0], k[1]);
        };
      }), R.extend = function(k, _) {
        return k.$i || (k(_, ce, R), k.$i = !0), R;
      }, R.locale = H, R.isDayjs = X, R.unix = function(k) {
        return R(1e3 * k);
      }, R.en = z[M], R.Ls = z, R.p = {}, R;
    });
  }(at)), at.exports;
}
var $a = Ma();
const He = /* @__PURE__ */ Da($a), Ia = ({ event: e, children: n }) => /* @__PURE__ */ t(
  "div",
  {
    className: x("rbc-event-wrapper", e.color ?? "", {
      "rbc-event-filled": e.variant === "filled",
      "rbc-event-white-label": e.whiteLabel
    }),
    children: n
  }
);
[...Intl.supportedValuesOf("timeZone")];
var pt = /* @__PURE__ */ ((e) => (e.Back = "back", e.Forward = "forward", e))(pt || {});
const Ba = ({
  disabled: e,
  viewMode: n,
  viewLabel: o,
  onMove: a,
  onMoveToday: r,
  onChangeView: i
}) => /* @__PURE__ */ D(
  W,
  {
    className: "rbc-toolbar",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.5,
    children: [
      /* @__PURE__ */ t(W, { className: "rbc-left-toolbar", children: /* @__PURE__ */ t(
        "button",
        {
          className: "rbc-btn-standalone rbc-btn-today",
          type: "button",
          onClick: r,
          disabled: e,
          children: "Today"
        }
      ) }),
      /* @__PURE__ */ D(W, { gap: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move back",
            disabled: e,
            onClick: () => {
              a(pt.Back);
            },
            children: /* @__PURE__ */ t(O, { icon: It })
          }
        ),
        /* @__PURE__ */ t("h2", { className: "rbc-toolbar-label", children: o }),
        /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move forward",
            disabled: e,
            onClick: () => {
              a(pt.Forward);
            },
            children: /* @__PURE__ */ t(O, { icon: It, rotation: 180 })
          }
        )
      ] }),
      /* @__PURE__ */ t("div", { className: "rbc-btn-group rbc-right-toolbar", children: ["Month", "Week", "Day"].map((l) => /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          disabled: e,
          onClick: () => {
            i(l.toLowerCase());
          },
          className: x({
            "rbc-active": n === l.toLowerCase()
          }),
          children: l
        },
        l
      )) })
    ]
  }
), Ra = ({ tag: e }) => ["a", "button"].includes(e), Ta = "_buttonAdjustments_1vavw_5", Aa = "_anchorAdjustments_1vavw_38", Wa = "_pointer_1vavw_49", Na = "_fullWidth_1vavw_53", tt = {
  buttonAdjustments: Ta,
  anchorAdjustments: Aa,
  pointer: Wa,
  fullWidth: Na
}, Jt = Ne(
  ({
    tagName: e = "button",
    children: n,
    className: o,
    disabled: a,
    fullWidth: r,
    href: i,
    onClick: c = () => null,
    testId: l,
    ...m
  }, d) => {
    const h = (f) => {
      a || c(f);
    }, b = {
      ...m,
      ...e === "button" ? { type: "button" } : {}
    }, y = !a && i ? i : void 0, p = i ? "a" : "button", g = Ra({ tag: e }) ? e : p;
    return /* @__PURE__ */ t(
      g,
      {
        ref: d,
        className: x(o, {
          [tt.buttonAdjustments]: g === "button",
          [tt.anchorAdjustments]: g === "a",
          [tt.pointer]: !a,
          [tt.fullWidth]: r
        }),
        disabled: a,
        onClick: h,
        href: y,
        "data-testid": l,
        ...b,
        children: n
      }
    );
  }
), W = We.forwardRef(
  ({ children: e, className: n, ...o }, a) => /* @__PURE__ */ t(
    hn,
    {
      "data-testid": "flexContainer",
      ref: a,
      className: n,
      display: "flex",
      ...o,
      children: e
    }
  )
), O = ({
  className: e,
  color: n,
  onClick: o,
  fixedWidth: a = !1,
  inverse: r = !1,
  listItem: i = !1,
  spin: c = !1,
  swapOpacity: l = !1,
  "data-testid": m,
  ...d
}) => {
  const h = ct(n, s.content.default);
  return /* @__PURE__ */ t(
    Pn,
    {
      className: e,
      color: h,
      "data-testid": m,
      fixedWidth: a,
      inverse: r,
      listItem: i,
      spin: c,
      swapOpacity: l,
      ...d
    }
  );
}, Ct = ({
  event: e,
  align: n = "start",
  timezone: o,
  tooltipPlacement: a
}) => {
  var h;
  const r = (e == null ? void 0 : e.variant) === "filled", i = e.icon ? e.icon : null, c = Intl.DateTimeFormat("en-US", {
    timeZone: o || Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(e == null ? void 0 : e.start), l = `${e.title}, ${c}`, m = /* @__PURE__ */ D(Jt, { className: "rbc-event-title", children: [
    e.title,
    ", ",
    c
  ] }), d = a ? /* @__PURE__ */ t(
    fe,
    {
      title: ((h = e == null ? void 0 : e.tooltipProps) == null ? void 0 : h.title) || l,
      placement: a,
      children: m
    }
  ) : m;
  return /* @__PURE__ */ D(W, { title: "", alignItems: n, gap: 0.5, "data-testid": e.title, children: [
    i ? /* @__PURE__ */ t(O, { icon: i, color: r ? "white" : e.color }) : null,
    /* @__PURE__ */ t("div", { className: "rbc-title-wrapper", children: d })
  ] });
}, Ea = ({
  event: e,
  timezone: n,
  tooltipPlacement: o
}) => /* @__PURE__ */ t(
  Ct,
  {
    align: "center",
    event: e,
    timezone: n,
    tooltipPlacement: o
  }
), Oa = ({
  initialDate: e,
  initialViewMode: n = "month",
  onRangeChange: o,
  onViewChange: a
}) => {
  const [r, i] = Fe(e), [c, l] = Fe(n), [m, d] = Fe(n);
  n !== m && (d(n), l(n));
  const h = {
    day: "d",
    week: "w",
    month: "M"
  }, b = (f) => {
    l(f), y(r, h[f]), a == null || a(f);
  }, y = (f, v) => {
    const S = He(f).startOf(v).toDate(), B = He(f).endOf(v).toDate();
    o == null || o({ start: S, end: B });
  };
  return {
    currentDate: r,
    viewMode: c,
    onChangeView: b,
    onMove: (f) => {
      if (f === "back") {
        const S = He(r).subtract(1, h[c]).toDate();
        i(S), y(S, h[c]);
        return;
      }
      const v = He(r).add(1, h[c]).toDate();
      i(v), y(v, h[c]);
    },
    onMoveToday: () => {
      const f = He().toDate();
      i(f), y(f, h[c]);
    }
  };
};
function za(e, n) {
  const o = He(n);
  switch (e) {
    case "week": {
      const a = o.clone().startOf("week"), r = o.clone().endOf("week");
      return `${a.format("MMMM DD")} - ${r.format(
        "DD, YYYY"
      )}`;
    }
    case "month":
      return o.format("MMMM, YYYY");
    case "day":
      return o.format("MMMM DD, YYYY");
    default:
      return "";
  }
}
const Ha = Tn(He), ns = ({
  events: e,
  initialDate: n,
  initialViewMode: o = "month",
  height: a,
  selectable: r = !0,
  loading: i = !1,
  grow: c = !0,
  className: l,
  classes: m,
  onNavigate: d = () => {
  },
  onViewChange: h = () => {
  },
  onView: b = () => {
  },
  tooltipPlacement: y,
  timezone: p,
  onRangeChange: g,
  restricted: f = !1,
  ...v
}) => {
  const { isMobile: S } = St(), { currentDate: B, viewMode: $, onChangeView: N, onMove: M, onMoveToday: z } = Oa({
    initialDate: n,
    initialViewMode: o,
    onRangeChange: g,
    onViewChange: h
  }), { containerClassName: U = "", rootClassName: X = "" } = m ?? {}, H = za($, B), R = S ? void 0 : y;
  return /* @__PURE__ */ D(
    "div",
    {
      className: x("rbc-calendar-container", U, {
        grow: c,
        loading: i,
        restricted: f
      }),
      children: [
        /* @__PURE__ */ t(
          Ba,
          {
            disabled: !!i,
            viewLabel: H,
            viewMode: $,
            onChangeView: N,
            onMoveToday: z,
            onMove: M
          }
        ),
        /* @__PURE__ */ t(
          An,
          {
            className: x(X, {
              "rbc-week-view": $ === "week"
            }),
            localizer: Ha,
            date: B,
            events: e,
            startAccessor: "start",
            view: $,
            onView: b,
            toolbar: !1,
            selectable: r,
            onNavigate: d,
            components: {
              day: {
                event: (I) => /* @__PURE__ */ t(
                  Ct,
                  {
                    ...I,
                    timezone: p,
                    tooltipPlacement: R
                  }
                )
              },
              week: {
                event: (I) => /* @__PURE__ */ t(
                  Ct,
                  {
                    ...I,
                    timezone: p,
                    tooltipPlacement: R
                  }
                )
              },
              month: {
                event: (I) => /* @__PURE__ */ t(
                  Ea,
                  {
                    ...I,
                    timezone: p,
                    tooltipPlacement: R
                  }
                )
              },
              eventWrapper: Ia
            },
            endAccessor: "end",
            views: ["month", "week", "day"],
            style: { height: a },
            ...v
          }
        )
      ]
    }
  );
}, Ga = ({ size: e }) => e === "default" ? "bodySm500" : "captionReg500", ja = "_container_1udz5_1", qa = "_fullWidth_1udz5_5", Ua = "_defaultContainer_1udz5_10", Ya = "_smallContainer_1udz5_19", Xa = "_warningContainer_1udz5_28", Za = "_tipContainer_1udz5_36", Ka = "_successContainer_1udz5_44", Pa = "_errorContainer_1udz5_52", Va = "_pendingContainer_1udz5_60", Ja = "_infoContainer_1udz5_68", Qa = "_miscContainer_1udz5_76", er = "_lockedContainer_1udz5_84", tr = "_infoNoteText_1udz5_92", nr = "_clearIcon_1udz5_97", or = "_dismissIcon_1udz5_104", ne = {
  container: ja,
  fullWidth: qa,
  defaultContainer: Ua,
  smallContainer: Ya,
  warningContainer: Xa,
  tipContainer: Za,
  successContainer: Ka,
  errorContainer: Pa,
  pendingContainer: Va,
  infoContainer: Ja,
  miscContainer: Qa,
  lockedContainer: er,
  infoNoteText: tr,
  clearIcon: nr,
  dismissIcon: or
}, ar = ({ size: e, children: n }) => typeof n == "string" ? /* @__PURE__ */ t(
  G,
  {
    variant: Ga({ size: e }),
    className: ne.infoNoteText,
    children: n
  }
) : /* @__PURE__ */ t(pe, { children: n }), Ht = Object.freeze({
  tip: {
    className: ne.tipContainer,
    icon: /* @__PURE__ */ t(O, { icon: zn })
  },
  warning: {
    className: ne.warningContainer,
    icon: /* @__PURE__ */ t(O, { icon: jn })
  },
  success: {
    className: ne.successContainer,
    icon: /* @__PURE__ */ t(O, { icon: Wn })
  },
  error: {
    className: ne.errorContainer,
    icon: /* @__PURE__ */ t(O, { icon: Gn })
  },
  pending: {
    className: ne.pendingContainer,
    icon: /* @__PURE__ */ t(O, { icon: On })
  },
  info: {
    className: ne.infoContainer,
    icon: /* @__PURE__ */ t(O, { icon: Nn })
  },
  misc: {
    className: ne.miscContainer,
    icon: /* @__PURE__ */ t(O, { icon: En })
  },
  locked: {
    className: ne.lockedContainer,
    icon: /* @__PURE__ */ t(O, { icon: Hn })
  }
}), Gt = Object.freeze({
  default: ne.defaultContainer,
  small: ne.smallContainer
}), rr = ({
  containerClass: e = "",
  children: n,
  variant: o = "tip",
  size: a = "default",
  className: r = "",
  customIcon: i = null,
  onDismiss: c = void 0,
  fullWidth: l = !0,
  linkProps: m = void 0
}) => {
  const d = c !== void 0, h = Ht[o] ?? Ht.tip, b = Gt[a] ?? Gt.default;
  return /* @__PURE__ */ D(
    W,
    {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      className: x(
        ne.container,
        h.className,
        b,
        r,
        e,
        {
          [ne.fullWidth]: l
        }
      ),
      children: [
        /* @__PURE__ */ D(W, { alignItems: "center", gap: a === "small" ? 1 : 1.5, children: [
          i || h.icon,
          /* @__PURE__ */ t(ar, { size: a, children: n })
        ] }),
        /* @__PURE__ */ D(W, { alignItems: "center", gap: 2, children: [
          m ? /* @__PURE__ */ t(
            dc,
            {
              ...m,
              forceUnderline: !m.forceNoUnderline,
              children: m.label
            }
          ) : null,
          d ? /* @__PURE__ */ t(
            Jt,
            {
              testId: "dismissIcon",
              "aria-label": "Dismiss",
              onClick: c,
              className: ne.dismissIcon,
              children: /* @__PURE__ */ t(O, { className: ne.clearIcon, icon: Zt })
            }
          ) : null
        ] })
      ]
    }
  );
}, ir = "_root_1ru8v_1", lr = {
  root: ir
}, cr = ({ variant: e, label: n, icon: o, className: a }) => /* @__PURE__ */ t(W, { className: lr.root, children: /* @__PURE__ */ t(rr, { variant: e, customIcon: o, className: a, children: n }) }), dr = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "search",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
], sr = (e) => dr.includes(e), ur = (e) => e === void 0 ? "div" : typeof e == "string" ? sr(e) ? e : "div" : e === et ? e : "div", mr = (e) => e === "a" || e === "button" || Qt(e), Qt = (e) => e === et, fr = "_root_10jao_1", gr = "_rounded_10jao_71", ut = {
  root: fr,
  "elevation-0": "_elevation-0_10jao_40",
  "elevation-100": "_elevation-100_10jao_44",
  "elevation-200": "_elevation-200_10jao_48",
  "elevation-300": "_elevation-300_10jao_52",
  "elevation-400": "_elevation-400_10jao_56",
  rounded: gr
}, xt = We.forwardRef(
  ({
    backgroundColor: e = "white",
    children: n,
    className: o = "",
    component: a = "div",
    href: r = "",
    onClick: i = () => null,
    elevation: c = 0,
    style: l = {},
    rounded: m = !0,
    width: d = "100%",
    newTab: h = !1,
    cardCapProps: b,
    "data-testid": y = "card",
    "aria-label": p
  }, g) => {
    const f = r && (Ge(r) || h), v = !!b, S = ur(a), B = mr(S), $ = Qt(S), N = v ? /* @__PURE__ */ D(W, { flexDirection: "column", children: [
      v && /* @__PURE__ */ t(cr, { ...b }),
      n
    ] }) : n, M = {
      className: x(o, ut.root, {
        [ut[`elevation-${c}`]]: c,
        [ut.rounded]: m
      }),
      ref: g,
      style: {
        backgroundColor: ct(e),
        width: d,
        ...l
      },
      "data-testid": y,
      "aria-label": p
    };
    return $ ? We.createElement(
      S,
      {
        ...M,
        onClick: i,
        rel: f ? "noreferrer" : void 0,
        target: f ? "_blank" : void 0,
        to: r
      },
      N
    ) : We.createElement(
      S,
      {
        ...M,
        ...B ? {
          onClick: i,
          rel: f ? "noreferrer" : void 0,
          target: f ? "_blank" : void 0,
          href: r
        } : {}
      },
      N
    );
  }
);
var se = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(se || {}), Je = /* @__PURE__ */ ((e) => (e.Left = "left", e.Right = "right", e))(Je || {});
const hr = "_root_6q1x5_2", pr = "_formControlLabel_6q1x5_9", Cr = "_descriptionText_6q1x5_16", br = "_customIcon_6q1x5_22", yr = "_disabled_6q1x5_39", _r = "_customIconSmall_6q1x5_44", Lr = "_customCheckedIcon_6q1x5_52", Sr = "_customCheckedIconContent_6q1x5_62", xr = "_checkbox_6q1x5_72", vr = "_checked_6q1x5_85", wr = "_indeterminate_6q1x5_86", kr = "_border_6q1x5_99", Dr = "_error_6q1x5_105", Fr = "_removeOffset_6q1x5_112", q = {
  root: hr,
  formControlLabel: pr,
  descriptionText: Cr,
  customIcon: br,
  disabled: yr,
  customIconSmall: _r,
  customCheckedIcon: Lr,
  customCheckedIconContent: Sr,
  checkbox: xr,
  checked: vr,
  indeterminate: wr,
  border: kr,
  error: Dr,
  removeOffset: Fr
}, Mr = ({ size: e, children: n, className: o }) => {
  const a = typeof n == "string", r = e === se.Small ? "captionReg500" : "bodyReg500";
  return a ? /* @__PURE__ */ t(G, { variant: r, className: x(q.labelText, o), children: n }) : /* @__PURE__ */ t(pe, { children: n });
}, $r = ({
  size: e,
  disabled: n
}) => /* @__PURE__ */ t(
  "span",
  {
    className: x(q.customIcon, {
      [q.customIconSmall]: e === se.Small,
      [q.disabled]: n
    })
  }
), Ir = ({
  size: e,
  disabled: n
}) => /* @__PURE__ */ t(
  "span",
  {
    className: x(q.customIcon, q.customCheckedIcon, {
      [q.customIconSmall]: e === se.Small,
      [q.disabled]: n
    }),
    children: /* @__PURE__ */ t(
      O,
      {
        size: e === se.Small ? "xs" : "sm",
        icon: qn,
        className: x(q.customCheckedIconContent, {
          [q.disabled]: n
        })
      }
    )
  }
), Br = ({
  size: e,
  disabled: n
}) => /* @__PURE__ */ t(
  "span",
  {
    className: x(q.customIcon, q.customCheckedIcon, {
      [q.customIconSmall]: e === se.Small,
      [q.disabled]: n
    }),
    children: /* @__PURE__ */ t(
      O,
      {
        size: e === se.Small ? "xs" : "sm",
        icon: Yn,
        className: x(q.customCheckedIconContent, {
          [q.disabled]: n
        })
      }
    )
  }
), Rr = ({
  size: e = se.Default,
  label: n = "",
  value: o,
  checked: a,
  disabled: r = !1,
  onChange: i = () => {
  },
  hasBorder: c = !1,
  hasError: l = !1,
  errorText: m,
  classes: d = {},
  description: h = "",
  indeterminate: b = !1,
  "data-testid": y,
  badgeProps: p,
  badgePosition: g = Je.Right,
  infoTooltipProps: f,
  "aria-label": v = "",
  removeOffset: S = !1,
  ...B
}) => {
  const $ = e === se.Small ? "captionSm500" : "bodySm400", N = (p == null ? void 0 : p.number) !== void 0, M = N && g === Je.Right, z = N && g === Je.Left, U = {
    color: (p == null ? void 0 : p.color) || Q.Neutral,
    number: (p == null ? void 0 : p.number) || 0,
    variant: (p == null ? void 0 : p.variant) || "filled"
  };
  return /* @__PURE__ */ D(W, { flexDirection: "column", children: [
    /* @__PURE__ */ t(
      Zn,
      {
        label: /* @__PURE__ */ D(pe, { children: [
          /* @__PURE__ */ D(
            W,
            {
              alignItems: "center",
              gap: 1,
              className: d == null ? void 0 : d.labelContainer,
              children: [
                z && /* @__PURE__ */ t(Ye, { ...U }),
                /* @__PURE__ */ t(Mr, { size: e, className: d == null ? void 0 : d.label, children: n }),
                M && /* @__PURE__ */ t(Ye, { ...U }),
                (f == null ? void 0 : f.title) && /* @__PURE__ */ t(
                  fe,
                  {
                    arrow: !0,
                    placement: (f == null ? void 0 : f.placement) || "right",
                    title: f == null ? void 0 : f.title,
                    children: /* @__PURE__ */ t(
                      O,
                      {
                        icon: Un,
                        size: e === se.Small ? "xs" : "sm"
                      }
                    )
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ t(
            G,
            {
              variant: $,
              className: x(q.descriptionText, d == null ? void 0 : d.description),
              children: h
            }
          )
        ] }),
        control: /* @__PURE__ */ t(
          Xn,
          {
            size: e === se.Small ? "small" : "medium",
            value: o,
            checked: a,
            disabled: r,
            onChange: i,
            indeterminate: b,
            "aria-label": v,
            icon: /* @__PURE__ */ t($r, { size: e, disabled: r }),
            checkedIcon: /* @__PURE__ */ t(Ir, { size: e, disabled: r }),
            indeterminateIcon: /* @__PURE__ */ t(Br, { size: e, disabled: r }),
            classes: {
              root: q.checkbox,
              checked: q.checked,
              disabled: q.disabled,
              indeterminate: q.indeterminate
            },
            ...y && { "data-testid": y },
            ...B
          }
        ),
        classes: {
          root: x(
            q.root,
            {
              [q.border]: c && n || l && m,
              [q.error]: l,
              [q.removeOffset]: S
            },
            d == null ? void 0 : d.root
          ),
          label: q.formControlLabel
        }
      }
    ),
    !!(l && m) && /* @__PURE__ */ t(G, { variant: "captionReg400", color: "criticalDefault", mt: 1, children: m })
  ] });
}, Tr = "_root_k88kk_4", Ar = "_branded_k88kk_9", Wr = "_rounded_k88kk_14", Nr = "_thin_k88kk_25", Er = "_children_k88kk_40", Or = "_horizontalWithChildren_k88kk_47", zr = "_leftText_k88kk_72", Hr = "_rightText_k88kk_75", Gr = "_verticalWithChildren_k88kk_82", ve = {
  root: Tr,
  branded: Ar,
  rounded: Wr,
  thin: Nr,
  children: Er,
  horizontalWithChildren: Or,
  leftText: zr,
  rightText: Hr,
  verticalWithChildren: Gr
}, os = We.forwardRef(
  ({
    light: e,
    variant: n,
    lineOnly: o,
    flexItem: a,
    children: r,
    textAlign: i,
    className: c,
    orientation: l,
    rounded: m,
    size: d = "default",
    color: h = "neutral",
    ...b
  }, y) => {
    const p = i === "left", g = i === "right", f = !!r, v = l === "vertical", S = l !== "vertical", B = v || f ? "div" : "hr";
    return /* @__PURE__ */ t(
      Kn,
      {
        ref: y,
        className: x(
          ve.root,
          {
            [ve.leftText]: p,
            [ve.rightText]: g,
            [ve.branded]: h === "branded",
            [ve.thin]: d === "thin",
            [ve.rounded]: m,
            [ve.horizontalWithChildren]: S && f,
            [ve.verticalWithChildren]: v && f
          },
          c
        ),
        flexItem: a,
        light: e,
        orientation: l,
        textAlign: i,
        variant: n,
        component: B,
        classes: {
          wrapper: ve.children
        },
        ...b,
        children: o ? null : r
      }
    );
  }
), jr = "_root_11ep6_1", qr = "_noPadding_11ep6_10", jt = {
  root: jr,
  noPadding: qr
}, en = We.forwardRef(
  ({ children: e, removePadding: n = !1, ...o }, a) => /* @__PURE__ */ t(
    Vn,
    {
      ref: a,
      disableRipple: !0,
      disableTouchRipple: !0,
      classes: {
        root: x(jt.root, { [jt.noPadding]: n })
      },
      ...o,
      children: e
    }
  )
), Ur = "_loadingIcon_raaev_1", Yr = "_loadingOverlay_raaev_10", Xr = "_coverParent_raaev_26", Zr = "_casefileVariant_raaev_33", nt = {
  loadingIcon: Ur,
  loadingOverlay: Yr,
  coverParent: Xr,
  casefileVariant: Zr
}, as = ({
  className: e = "",
  iconColor: n,
  iconType: o = "line-scale",
  coverParent: a = !1,
  variant: r = "default",
  noFadeIn: i = !1,
  paperProps: c = {},
  ...l
}) => {
  const m = ct(n, s.color.grayDark);
  return /* @__PURE__ */ t(
    Jn,
    {
      classes: {
        root: x(nt.loadingOverlay, e, a && nt.coverParent, {
          [nt.casefileVariant]: r === "casefile"
        })
      },
      "data-testid": "loading-overlay",
      ...c,
      children: /* @__PURE__ */ t(
        Kt,
        {
          className: nt.loadingIcon,
          name: o,
          color: m,
          fadeIn: i ? "none" : "half",
          ...l
        }
      )
    }
  );
}, rs = ({ children: e }) => /* @__PURE__ */ t(Sn, { theme: Ro, children: e });
var De = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.LARGE = "large", e))(De || {}), bt = /* @__PURE__ */ ((e) => (e.SEGMENTED = "segmented", e.CONTINUOUS = "continuous", e))(bt || {});
const Kr = "_continuousRoot_1gyl4_1", Pr = "_continuousRootLarge_1gyl4_8", Vr = "_continuousBar_1gyl4_12", mt = {
  continuousRoot: Kr,
  continuousRootLarge: Pr,
  continuousBar: Vr
}, Jr = ({
  size: e = De.DEFAULT,
  allowEmpty: n = !1,
  "aria-label": o = "",
  currentStep: a = 0,
  totalSteps: r = 1,
  classes: i = {}
}) => {
  const l = (n ? a : Math.max(a, 1)) / r * 100;
  return /* @__PURE__ */ t(W, { width: "100%", children: /* @__PURE__ */ t(
    Qn,
    {
      variant: "determinate",
      value: Number.isFinite(l) ? l : 0,
      "aria-label": o,
      "data-testid": "progress-bar-continuous",
      classes: {
        determinate: x(
          mt.continuousRoot,
          {
            [mt.continuousRootLarge]: e === De.LARGE
          },
          i == null ? void 0 : i.continuousRoot
        ),
        bar: x(mt.continuousBar, i == null ? void 0 : i.continuousBar)
      }
    }
  ) });
}, Qr = "_segmentedContainer_1v1el_1", ei = "_segment_1v1el_1", ti = "_largeSegment_1v1el_12", ni = "_completeSegment_1v1el_16", oi = "_currentSegment_1v1el_20", ai = "_errorSegment_1v1el_24", qe = {
  segmentedContainer: Qr,
  segment: ei,
  largeSegment: ti,
  completeSegment: ni,
  currentSegment: oi,
  errorSegment: ai
}, ri = ({
  completedSteps: e = [],
  currentStep: n = 0,
  errorSteps: o = [],
  size: a = De.DEFAULT,
  classes: r = {},
  totalSteps: i = 0,
  "aria-label": c = ""
}) => {
  const l = Array.from({ length: i }, (m, d) => d);
  return /* @__PURE__ */ t(
    W,
    {
      className: x(qe.segmentedContainer, r == null ? void 0 : r.segmentedContainer),
      flexGrow: 1,
      columnGap: 1,
      alignItems: "center",
      "aria-label": c,
      "data-testid": "progress-bar-segmented",
      children: l.map((m) => /* @__PURE__ */ t(
        "div",
        {
          "data-testid": `segment-${m}`,
          className: x(
            qe.segment,
            {
              [qe.largeSegment]: a === De.LARGE,
              [qe.completeSegment]: e.includes(m),
              [qe.currentSegment]: n === m,
              [qe.errorSegment]: o.includes(m)
            },
            r == null ? void 0 : r.segment
          )
        },
        m
      ))
    }
  );
}, is = ({
  bottomLabel: e,
  size: n = De.DEFAULT,
  topLabel: o,
  valueLabel: a,
  variant: r = bt.SEGMENTED,
  classes: i = {},
  ...c
}) => {
  const l = r === bt.SEGMENTED, d = {
    [De.DEFAULT]: "captionReg500",
    [De.LARGE]: "bodySm500"
  }[n], h = o || a;
  return /* @__PURE__ */ D(
    W,
    {
      className: i == null ? void 0 : i.rootContainer,
      flexDirection: "column",
      gap: n === De.LARGE ? 0.75 : 0.5,
      children: [
        h && /* @__PURE__ */ D(W, { justifyContent: "space-between", children: [
          o && /* @__PURE__ */ t(G, { variant: d, className: i == null ? void 0 : i.topLabel, children: o }),
          a && /* @__PURE__ */ t(G, { variant: d, className: i == null ? void 0 : i.valueLabel, children: a })
        ] }),
        /* @__PURE__ */ t(W, { flexGrow: 1, alignItems: "center", children: l ? /* @__PURE__ */ t(ri, { size: n, classes: i, ...c }) : /* @__PURE__ */ t(Jr, { size: n, classes: i, ...c }) }),
        e && /* @__PURE__ */ t(G, { variant: d, className: i == null ? void 0 : i.bottomLabel, children: e })
      ]
    }
  );
};
var Ae = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e.Large = "large", e))(Ae || {}), Te = /* @__PURE__ */ ((e) => (e.Start = "start", e.End = "end", e.Top = "top", e.Bottom = "bottom", e))(Te || {});
const ii = "_toggleButton_1waos_1", li = "_disabled_1waos_9", ci = "_selected_1waos_24", di = "_small_1waos_28", si = "_large_1waos_32", ui = "_toggleButtonFullWidth_1waos_36", mi = "_toggleButtonText_1waos_40", fi = "_toggleButtonTextSelected_1waos_44", gi = "_toggleButtonTextDisabled_1waos_48", we = {
  toggleButton: ii,
  disabled: li,
  selected: ci,
  small: di,
  large: si,
  toggleButtonFullWidth: ui,
  toggleButtonText: mi,
  toggleButtonTextSelected: fi,
  toggleButtonTextDisabled: gi
}, hi = ({
  icon: e,
  label: n,
  tooltip: o,
  confirmationPopover: a,
  value: r,
  isDisabled: i,
  isSelected: c,
  iconDirection: l,
  onChange: m,
  onClick: d,
  fullWidth: h,
  size: b,
  ...y
}) => {
  const p = b === Ae.Small, g = b === Ae.Large, f = {
    [Ae.Small]: "bodySm600",
    [Ae.Default]: "bodySm600",
    [Ae.Large]: "bodyReg600"
  }, v = [Te.Top, Te.Bottom].includes(
    l
  ) ? "column" : "row", S = [Te.Start, Te.Top].includes(
    l
  ), B = [Te.End, Te.Bottom].includes(
    l
  ), $ = () => /* @__PURE__ */ t(fe, { placement: "top", title: o ?? "", children: /* @__PURE__ */ D(W, { alignItems: "center", gap: 1, flexDirection: v, children: [
    S && e,
    /* @__PURE__ */ t(
      G,
      {
        variant: f[b],
        className: x(we.toggleButtonText, {
          [we.toggleButtonTextSelected]: c,
          [we.toggleButtonTextDisabled]: i
        }),
        children: n
      }
    ),
    B && e
  ] }) }), N = {
    key: r,
    value: r,
    selected: c,
    disabled: i,
    classes: {
      root: x(we.toggleButton, {
        [we.toggleButtonFullWidth]: h,
        [we.small]: p,
        [we.large]: g
      }),
      selected: we.selected,
      disabled: we.disabled
    }
  }, {
    confirmationText: M,
    confirmationPopoverCancelButtonText: z,
    confirmationButtonText: U,
    confirmationButtonColor: X
  } = a || {};
  return a && !c ? /* @__PURE__ */ t(
    wt,
    {
      withCustomAnchor: !0,
      anchorContent: ({
        anchorElementProps: H
      }) => /* @__PURE__ */ t(
        Bt,
        {
          ...y,
          ...N,
          onClick: (R) => {
            var I;
            R.preventDefault(), R.stopPropagation(), (I = H == null ? void 0 : H.onClick) == null || I.call(
              H,
              R
            );
          },
          children: $()
        }
      ),
      popoverContent: ({ setAnchor: H }) => /* @__PURE__ */ D("div", { children: [
        M && /* @__PURE__ */ t(G, { variant: "bodySm400", mb: 1.5, children: M }),
        /* @__PURE__ */ D(
          W,
          {
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ t(
                rt,
                {
                  label: z ?? "Cancel",
                  size: Me.Small,
                  color: te.Default,
                  variant: _e.Text,
                  onClick: (R) => {
                    if (c) {
                      R.preventDefault(), R.stopPropagation();
                      return;
                    }
                    R.stopPropagation(), H(null);
                  }
                }
              ),
              /* @__PURE__ */ t(
                rt,
                {
                  label: U ?? "Confirm",
                  size: Me.Small,
                  variant: _e.Outlined,
                  color: X ?? te.Default,
                  onClick: async (R) => {
                    await (d == null ? void 0 : d(
                      R,
                      r
                    )), m == null || m(
                      R,
                      r
                    ), H(null);
                  }
                }
              )
            ]
          }
        )
      ] })
    },
    r
  ) : /* @__PURE__ */ t(
    Bt,
    {
      ...y,
      ...N,
      onClick: (H) => {
        if (c) {
          H.preventDefault(), H.stopPropagation();
          return;
        }
        d == null || d(H, r), m == null || m(H, r);
      },
      children: $()
    }
  );
}, pi = "_toggleButtonGroup_dedp6_1", Ci = "_small_dedp6_8", qt = {
  toggleButtonGroup: pi,
  small: Ci
}, ls = ({
  value: e,
  buttons: n,
  onChange: o,
  size: a = Ae.Default,
  iconDirection: r = Te.Start,
  disabled: i = !1,
  className: c,
  fullWidth: l = !1,
  ...m
}) => {
  const d = a === Ae.Small;
  return /* @__PURE__ */ t(
    eo,
    {
      value: e,
      onChange: o,
      disabled: i,
      className: x(
        qt.toggleButtonGroup,
        {
          [qt.small]: d
        },
        c
      ),
      fullWidth: l,
      exclusive: !0,
      ...m,
      children: n.map((h) => {
        const {
          buttonValue: b,
          disabled: y,
          icon: p,
          label: g,
          tooltip: f,
          confirmationPopover: v,
          onClick: S,
          ...B
        } = h;
        return /* @__PURE__ */ t(
          hi,
          {
            icon: p,
            label: g,
            tooltip: f ?? "",
            confirmationPopover: v,
            iconDirection: r,
            isDisabled: i || !!y,
            isSelected: e === b,
            onChange: o,
            onClick: S,
            fullWidth: l,
            ...B,
            value: b,
            size: a
          },
          b
        );
      })
    }
  );
}, tn = () => /* @__PURE__ */ D(W, { flexDirection: "column", width: "100%", children: [
  /* @__PURE__ */ t(ue, { variant: "text", width: "25%" }),
  /* @__PURE__ */ t(ue, { variant: "text", width: "75%" }),
  /* @__PURE__ */ t(ue, { variant: "text", width: "60%" })
] }), bi = "_root_31ksi_1", yi = {
  root: bi
}, _i = ({ "data-testid": e }) => /* @__PURE__ */ t(xt, { className: yi.root, "data-testid": e, children: /* @__PURE__ */ D(W, { columnGap: 1, children: [
  /* @__PURE__ */ t(ue, { height: 40, width: 40, variant: "circular" }),
  /* @__PURE__ */ t(tn, {})
] }) }), Li = "_root_31ksi_1", Si = {
  root: Li
}, xi = ({ "data-testid": e }) => /* @__PURE__ */ t(xt, { className: Si.root, "data-testid": e, children: /* @__PURE__ */ t(tn, {}) }), vi = ({ "data-testid": e }) => /* @__PURE__ */ D(W, { columnGap: 1, alignItems: "center", "data-testid": e, children: [
  /* @__PURE__ */ t(ue, { height: 32, width: 32, variant: "circular" }),
  /* @__PURE__ */ t(ue, { variant: "text", width: 80, height: 24 })
] }), wi = ({ "data-testid": e }) => /* @__PURE__ */ t(W, { justifyContent: "center", "data-testId": e, children: /* @__PURE__ */ t(Kt, { color: s.color.grayLight }) }), ki = "_card_xgnkm_1", Di = "_metaData_xgnkm_5", Fi = "_errorMessage_xgnkm_10", ft = {
  card: ki,
  metaData: Di,
  errorMessage: Fi
}, Mi = ({
  errorMessage: e = "",
  "data-testid": n
}) => /* @__PURE__ */ t(xt, { className: ft.card, "data-testid": n, children: /* @__PURE__ */ D(W, { flexDirection: "column", children: [
  e && /* @__PURE__ */ t(
    G,
    {
      component: "h3",
      variant: "titleSm700",
      color: "orangeDark",
      className: ft.errorMessage,
      children: e
    }
  ),
  /* @__PURE__ */ t(ue, { height: 200, variant: "rectangular" }),
  /* @__PURE__ */ D(
    W,
    {
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: "0",
      className: ft.metaData,
      children: [
        /* @__PURE__ */ D(W, { columnGap: 1, alignItems: "center", flexGrow: 1, children: [
          /* @__PURE__ */ t(ue, { width: 32, height: 32, variant: "circular" }),
          /* @__PURE__ */ D(W, { flexDirection: "column", flexGrow: 1, children: [
            /* @__PURE__ */ t(ue, { height: 20, width: "75%" }),
            /* @__PURE__ */ t(ue, { height: 20, width: "90%" })
          ] })
        ] }),
        /* @__PURE__ */ t(W, { alignItems: "center", justifyContent: "flex-end", flexGrow: 1, children: /* @__PURE__ */ t(ue, { height: 40, width: "50%" }) })
      ]
    }
  )
] }) }), $i = {
  listItem: _i,
  listItemText: xi,
  threeDots: wi,
  tableCellUser: vi,
  videoCard: Mi
}, cs = ({
  className: e = "",
  component: n = void 0,
  count: o = 1,
  "data-testid": a,
  ...r
}) => {
  const i = n ? $i[n] : void 0;
  return Array(o).fill(0).map(
    (c) => i ? /* @__PURE__ */ t(i, { "data-testid": a }, c) : /* @__PURE__ */ t(
      ue,
      {
        className: e,
        "data-testid": a,
        ...r
      },
      c
    )
  );
};
var Ve = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e.Large = "large", e))(Ve || {}), nn = /* @__PURE__ */ ((e) => (e.Transparent = "transparent", e.Filled = "filled", e))(nn || {}), on = /* @__PURE__ */ ((e) => (e.Outlined = "outlined", e.Filled = "filled", e))(on || {});
const Ii = "_container_1cr8e_1", Bi = "_large_1cr8e_9", Ri = "_dot_1cr8e_13", Ti = "_small_1cr8e_18", Ai = "_critical_1cr8e_49", Wi = "_dotOutlined_1cr8e_57", Ni = "_statusLozengeText_1cr8e_66", Ei = "_neutral_1cr8e_71", Oi = "_warning_1cr8e_93", zi = "_success_1cr8e_115", Hi = "_info_1cr8e_137", Gi = "_note_1cr8e_159", ji = "_progress_1cr8e_181", qi = "_transparentBg_1cr8e_200", Oe = {
  container: Ii,
  large: Bi,
  dot: Ri,
  small: Ti,
  default: "_default_1cr8e_28",
  critical: Ai,
  dotOutlined: Wi,
  statusLozengeText: Ni,
  neutral: Ei,
  warning: Oi,
  success: zi,
  info: Hi,
  note: Gi,
  progress: ji,
  transparentBg: qi
}, ds = ({
  className: e = "",
  color: n = Q.Success,
  "data-testid": o,
  dot: a = !1,
  dotVariant: r = on.Filled,
  icon: i,
  label: c,
  size: l = Ve.Default,
  variant: m = nn.Filled
}) => {
  const d = Vt(n), h = Oe[d], b = Oe[l], y = {
    [Ve.Small]: "captionReg600",
    [Ve.Default]: "bodySm600",
    [Ve.Large]: "bodyReg600"
  };
  return /* @__PURE__ */ D(
    W,
    {
      alignItems: "center",
      className: x(Oe.container, h, b, e, {
        [Oe.transparentBg]: m === "transparent"
      }),
      "data-testid": o,
      children: [
        i,
        a && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "status-lozenge-dot",
            className: x(Oe.dot, {
              [Oe.dotOutlined]: r === "outlined"
            })
          }
        ),
        /* @__PURE__ */ t(G, { variant: y[l], className: Oe.statusLozengeText, children: c })
      ]
    }
  );
};
var yt = /* @__PURE__ */ ((e) => (e.Key = "key", e.Filter = "filter", e))(yt || {}), _t = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e))(_t || {});
const Ui = "_segmentsContainer_f4woj_1", Yi = "_segmentBar_f4woj_21", Xi = "_segmentBarDefault_f4woj_26", Zi = "_segmentBarSmall_f4woj_30", Ki = "_success_f4woj_35", Pi = "_critical_f4woj_39", Vi = "_warning_f4woj_43", Ji = "_progress_f4woj_47", Qi = "_info_f4woj_51", el = "_note_f4woj_55", tl = "_neutral_f4woj_59", nl = "_segmentFilterLabel_f4woj_64", ol = "_segmentFilterLabelSmall_f4woj_68", ze = {
  segmentsContainer: Ui,
  segmentBar: Yi,
  segmentBarDefault: Xi,
  segmentBarSmall: Zi,
  success: Ki,
  critical: Pi,
  warning: Vi,
  progress: Ji,
  info: Qi,
  note: el,
  neutral: tl,
  segmentFilterLabel: nl,
  segmentFilterLabelSmall: ol
}, ss = ({
  variant: e = yt.Key,
  size: n = _t.Default,
  segments: o = [],
  keyLabel: a,
  containerClass: r,
  showLegend: i = !0,
  onClick: c = () => {
  }
}) => {
  const { isDesktop: l } = St(), m = e === yt.Filter, d = n === _t.Small, h = Math.max(
    o.reduce((g, f) => g + f.count, 0),
    1
  ), b = o.map((g) => {
    const f = g.count / h * 100 || 0;
    return {
      ...g,
      percent: f
    };
  }), y = (g) => g.percent ? /* @__PURE__ */ t(
    fe,
    {
      placement: "top",
      title: g.tooltip || "",
      children: /* @__PURE__ */ t(
        W,
        {
          className: x(
            ze.segmentBar,
            ze[g.color || Q.Success],
            d ? ze.segmentBarSmall : ze.segmentBarDefault
          ),
          width: `${g.percent}%`,
          onClick: () => c(g),
          component: "button",
          "aria-label": g.label
        }
      )
    },
    g.label
  ) : null, p = (g) => {
    var M;
    const f = g.label || "", v = g.count || 0, S = g.legendTooltip !== void 0 ? g.legendTooltip : `${(M = g.percent) == null ? void 0 : M.toFixed(2)}%`, B = !!g.checked, $ = g.onChange || (() => {
    }), N = d ? "captionReg500" : "bodyReg500";
    return /* @__PURE__ */ t(fe, { placement: "top", title: S, children: /* @__PURE__ */ t("div", { children: m ? /* @__PURE__ */ t(W, { columnGap: 0.5, children: /* @__PURE__ */ t(
      Rr,
      {
        label: /* @__PURE__ */ t(G, { variant: N, children: f }),
        onChange: (z) => $(z.target.checked),
        size: d ? se.Small : se.Default,
        checked: B,
        badgeProps: {
          number: v,
          color: g.color
        },
        badgePosition: Je.Left,
        classes: {
          label: x(ze.segmentFilterLabel, {
            [ze.segmentFilterLabelSmall]: d
          })
        }
      }
    ) }) : /* @__PURE__ */ D(W, { gap: 0.5, alignItems: "center", children: [
      /* @__PURE__ */ t(Ye, { number: v, color: g.color }),
      /* @__PURE__ */ t(G, { variant: N, children: f })
    ] }) }) }, g.label);
  };
  return /* @__PURE__ */ D(
    W,
    {
      flexDirection: "column",
      rowGap: 1,
      width: "100%",
      alignItems: "center",
      className: r,
      children: [
        /* @__PURE__ */ t(W, { columnGap: 0.25, className: ze.segmentsContainer, children: b.map((g) => y(g)) }),
        /* @__PURE__ */ D(
          W,
          {
            alignItems: "center",
            flexWrap: "wrap",
            columnGap: m ? 6 : 2,
            rowGap: 1,
            justifyContent: m ? "center" : void 0,
            width: l ? "max-content" : void 0,
            children: [
              !m && a && /* @__PURE__ */ D(G, { variant: "captionReg500", color: "secondary", children: [
                a,
                ":"
              ] }),
              i && b.map((g) => p(g))
            ]
          }
        )
      ]
    }
  );
};
var it = /* @__PURE__ */ ((e) => (e.Vertical = "vertical", e.Horizontal = "horizontal", e))(it || {}), an = /* @__PURE__ */ ((e) => (e.FullWidth = "fullWidth", e.Scrollable = "scrollable", e.Standard = "standard", e))(an || {}), ke = /* @__PURE__ */ ((e) => (e.Small = "small", e.Default = "default", e.Large = "large", e))(ke || {}), vt = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e.Start = "start", e.End = "end", e))(vt || {});
const al = "_tab_1kn6s_1", rl = "_disabled_1kn6s_19", il = "_selected_1kn6s_29", ll = "_small_1kn6s_36", cl = "_large_1kn6s_46", dl = "_vertical_1kn6s_52", sl = "_iconWrapper_1kn6s_67", ul = "_selectedIcon_1kn6s_73", ml = "_disabledIcon_1kn6s_77", fl = "_smallIcon_1kn6s_81", gl = "_defaultIcon_1kn6s_86", hl = "_largeIcon_1kn6s_87", pl = "_badge_1kn6s_93", ae = {
  tab: al,
  disabled: rl,
  selected: il,
  small: ll,
  default: "_default_1kn6s_41",
  large: cl,
  vertical: dl,
  iconWrapper: sl,
  selectedIcon: ul,
  disabledIcon: ml,
  smallIcon: fl,
  defaultIcon: gl,
  largeIcon: hl,
  badge: pl
}, Cl = ({
  value: e,
  size: n = ke.Default,
  label: o,
  disabled: a = !1,
  tooltipProps: r,
  badgeProps: i,
  icon: c,
  iconPosition: l = vt.Start,
  classes: m = {},
  orientation: d,
  isSelected: h = !1,
  ...b
}) => {
  const y = n === ke.Small, p = n === ke.Default, g = n === ke.Large, f = {
    [ke.Default]: F.bodySm500,
    [ke.Small]: F.captionReg500,
    [ke.Large]: F.bodyReg500
  }, v = x(
    ae.tab,
    {
      [ae.small]: y,
      [ae.default]: p,
      [ae.large]: g,
      [ae.disabled]: a,
      [ae.vertical]: d === it.Vertical,
      [ae.selected]: h
    },
    m == null ? void 0 : m.root
  ), S = x(
    ae.iconWrapper,
    {
      [ae.smallIcon]: y,
      [ae.defaultIcon]: p,
      [ae.largeIcon]: g,
      [ae.selectedIcon]: h,
      [ae.disabledIcon]: a
    },
    m == null ? void 0 : m.iconWrapper
  ), B = /* @__PURE__ */ D(pe, { children: [
    typeof o == "string" ? /* @__PURE__ */ t(G, { variant: f[n], children: o }) : o,
    i && /* @__PURE__ */ t("div", { className: ae.badge, children: /* @__PURE__ */ t(Ye, { ...i, size: n }) })
  ] }), $ = (r == null ? void 0 : r.placement) || (d === it.Horizontal ? "top" : "right");
  return /* @__PURE__ */ t(
    fe,
    {
      ...r,
      placement: $,
      title: (r == null ? void 0 : r.title) ?? "",
      children: /* @__PURE__ */ t(
        no,
        {
          value: e,
          disabled: a,
          classes: {
            ...m,
            root: v,
            iconWrapper: S
          },
          label: B,
          icon: c,
          iconPosition: l,
          ...b
        }
      )
    }
  );
}, bl = "_tabs_1hrcg_1", yl = "_flexContainer_1hrcg_6", _l = "_indicator_1hrcg_11", Ll = "_indicatorHorizontal_1hrcg_15", Sl = "_indicatorVertical_1hrcg_19", xl = "_hideIndicator_1hrcg_26", Ue = {
  tabs: bl,
  flexContainer: yl,
  indicator: _l,
  indicatorHorizontal: Ll,
  indicatorVertical: Sl,
  hideIndicator: xl
}, us = ({
  tabs: e,
  value: n,
  hideIndicator: o = !1,
  iconPosition: a = vt.Start,
  onTabSelect: r,
  orientation: i = it.Horizontal,
  variant: c = an.Scrollable,
  size: l = ke.Default,
  tabClasses: m,
  classes: d,
  allowScrollButtonsMobile: h = !1,
  ...b
}) => {
  const y = (f, v) => {
    r == null || r(v);
  }, p = {
    iconPosition: a,
    size: l,
    classes: m,
    orientation: i
  }, g = e.every((f) => f.value !== void 0) ? e.findIndex((f) => f.value === n) : n;
  return /* @__PURE__ */ t(
    to,
    {
      allowScrollButtonsMobile: h,
      value: n,
      onChange: y,
      variant: c,
      orientation: i,
      classes: {
        root: x(Ue.tabs, d == null ? void 0 : d.root),
        flexContainer: Ue.flexContainer,
        indicator: x(Ue.indicator, {
          [Ue.indicatorHorizontal]: i === "horizontal",
          [Ue.indicatorVertical]: i === "vertical",
          [Ue.hideIndicator]: o
        }),
        ...d
      },
      ...b,
      children: e == null ? void 0 : e.map((f, v) => f.hidden ? null : /* @__PURE__ */ t(
        Cl,
        {
          isSelected: g === v,
          ...p,
          ...f
        },
        f.label || v
      ))
    }
  );
};
var Qe = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.DEFAULT = "default", e))(Qe || {}), me = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.NUMBER = "number", e.PASSWORD = "password", e.EMAIL = "email", e.SEARCH = "search", e.PHONE = "tel", e.URL = "url", e))(me || {});
const vl = ({
  charCount: e,
  charLimit: n,
  error: o,
  hasCharLimitError: a,
  helperId: r,
  helperText: i,
  isSmall: c
}) => /* @__PURE__ */ D(pe, { children: [
  /* @__PURE__ */ t(
    G,
    {
      component: "span",
      color: o ? "criticalDefault" : void 0,
      variant: c ? "captionSm500" : "captionReg500",
      id: r,
      children: i
    }
  ),
  n && /* @__PURE__ */ D(
    G,
    {
      component: "span",
      color: o || a ? "criticalDefault" : void 0,
      variant: c ? "captionSm500" : "captionReg500",
      children: [
        e,
        "/",
        n
      ]
    }
  )
] }), wl = "_root_1dj9q_1", kl = "_inputRoot_1dj9q_5", Dl = "_disabled_1dj9q_12", Fl = "_inputDisabled_1dj9q_12", Ml = "_input_1dj9q_5", $l = "_inputNotchedOutline_1dj9q_18", Il = "_inputFocused_1dj9q_39", Bl = "_small_1dj9q_43", Rl = "_fullWidth_1dj9q_60", Tl = "_label_1dj9q_64", Al = "_helperTextBox_1dj9q_69", Wl = "_compactCharLimit_1dj9q_75", Nl = "_hideNumberArrows_1dj9q_82", El = "_startAdornment_1dj9q_95", re = {
  root: wl,
  inputRoot: kl,
  disabled: Dl,
  inputDisabled: Fl,
  input: Ml,
  inputNotchedOutline: $l,
  inputFocused: Il,
  small: Bl,
  fullWidth: Rl,
  label: Tl,
  helperTextBox: Al,
  compactCharLimit: Wl,
  hideNumberArrows: Nl,
  startAdornment: El
}, Xe = Ne(
  ({
    charLimit: e,
    compactCharLimit: n,
    "data-testid": o,
    disabled: a,
    enableHardLimit: r,
    endAdornment: i,
    error: c,
    fullWidth: l,
    helperText: m,
    hideNumberArrows: d,
    id: h,
    inputRootClass: b,
    label: y,
    loading: p,
    required: g,
    rootClass: f,
    size: v = Qe.DEFAULT,
    type: S,
    useFloatingLabel: B,
    value: $,
    ...N
  }, M) => {
    var _;
    const z = "helper-text", U = typeof $ == "string" ? $.length : String($ || "").length, X = !!e && U > e, H = r ? String($ || "").slice(0, e) : $, R = v === Qe.SMALL, I = !!(c || X), ce = p ? /* @__PURE__ */ t(
      O,
      {
        "data-testid": "loader-icon",
        spin: !0,
        icon: oo,
        color: "secondary"
      }
    ) : N == null ? void 0 : N.startAdornment, Le = {
      ...N.inputProps,
      "data-testid": o,
      ...r && e ? { maxLength: e } : {},
      autocomplete: "new-password",
      form: {
        autocomplete: "off"
      },
      size: (_ = N.placeholder) == null ? void 0 : _.length
    }, k = R ? "captionReg500" : "bodySm500";
    return /* @__PURE__ */ D(
      W,
      {
        flexDirection: "column",
        gap: 0.5,
        width: l ? "100%" : void 0,
        children: [
          !B && /* @__PURE__ */ D(
            G,
            {
              "data-testid": "input-label",
              component: "label",
              variant: k,
              htmlFor: h || y,
              children: [
                y,
                g && /* @__PURE__ */ D(pe, { children: [
                  " ",
                  /* @__PURE__ */ t(
                    G,
                    {
                      variant: k,
                      component: "span",
                      color: "criticalDefault",
                      children: "*"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ t(
            pn,
            {
              "aria-describedby": m ? z : void 0,
              autoComplete: "new-password",
              disabled: a || p,
              error: I,
              FormHelperTextProps: {
                classes: {
                  root: x(re.helperTextBox, {
                    [re.compactCharLimit]: n
                  })
                }
              },
              helperText: !m && !e ? void 0 : /* @__PURE__ */ t(
                vl,
                {
                  charCount: U,
                  charLimit: e,
                  error: c,
                  hasCharLimitError: X,
                  helperId: z,
                  helperText: m,
                  isSmall: R
                }
              ),
              id: h || y,
              inputProps: Le,
              label: B ? y : void 0,
              ref: M,
              type: S,
              ...N,
              classes: {
                ...N.classes,
                root: x(re.root, f, {
                  [re.fullWidth]: l,
                  [re.disabled]: a || p,
                  [re.hideNumberArrows]: d && S === me.NUMBER
                })
              },
              InputLabelProps: {
                classes: { root: x(re.label) },
                ...N.InputLabelProps
              },
              InputProps: {
                ...N.InputProps,
                startAdornment: ce,
                endAdornment: i,
                classes: {
                  root: x(re.inputRoot, b),
                  input: x(re.input, {
                    [re.small]: R
                  }),
                  notchedOutline: re.inputNotchedOutline,
                  focused: re.inputFocused,
                  disabled: re.inputDisabled,
                  adornedStart: re.startAdornment
                }
              },
              value: H,
              variant: "outlined"
            }
          )
        ]
      }
    );
  }
), Ol = "https://", Ut = [
  {
    name: "United States",
    countryCode2Letter: "US",
    phoneCode: "+1",
    flag: "🇺🇸"
  },
  {
    name: "Aruba",
    countryCode2Letter: "AW",
    phoneCode: "+297",
    flag: "🇦🇼"
  },
  {
    name: "Afghanistan",
    countryCode2Letter: "AF",
    phoneCode: "+93",
    flag: "🇦🇫"
  },
  {
    name: "Angola",
    countryCode2Letter: "AO",
    phoneCode: "+244",
    flag: "🇦🇴"
  },
  {
    name: "Anguilla",
    countryCode2Letter: "AI",
    phoneCode: "+1",
    flag: "🇦🇮"
  },
  {
    name: "Åland Islands",
    countryCode2Letter: "AX",
    phoneCode: "+358",
    flag: "🇦🇽"
  },
  {
    name: "Albania",
    countryCode2Letter: "AL",
    phoneCode: "+355",
    flag: "🇦🇱"
  },
  {
    name: "Andorra",
    countryCode2Letter: "AD",
    phoneCode: "+376",
    flag: "🇦🇩"
  },
  {
    name: "United Arab Emirates",
    countryCode2Letter: "AE",
    phoneCode: "+971",
    flag: "🇦🇪"
  },
  {
    name: "Argentina",
    countryCode2Letter: "AR",
    phoneCode: "+54",
    flag: "🇦🇷"
  },
  {
    name: "Armenia",
    countryCode2Letter: "AM",
    phoneCode: "+374",
    flag: "🇦🇲"
  },
  {
    name: "American Samoa",
    countryCode2Letter: "AS",
    phoneCode: "+1",
    flag: "🇦🇸"
  },
  {
    name: "Antarctica",
    countryCode2Letter: "AQ",
    phoneCode: "+672",
    flag: "🇦🇶"
  },
  {
    name: "French Southern Territories",
    countryCode2Letter: "TF",
    phoneCode: "+262",
    flag: "🇹🇫"
  },
  {
    name: "Antigua and Barbuda",
    countryCode2Letter: "AG",
    phoneCode: "+1",
    flag: "🇦🇬"
  },
  {
    name: "Australia",
    countryCode2Letter: "AU",
    phoneCode: "+61",
    flag: "🇦🇺"
  },
  {
    name: "Austria",
    countryCode2Letter: "AT",
    phoneCode: "+43",
    flag: "🇦🇹"
  },
  {
    name: "Azerbaijan",
    countryCode2Letter: "AZ",
    phoneCode: "+994",
    flag: "🇦🇿"
  },
  {
    name: "Burundi",
    countryCode2Letter: "BI",
    phoneCode: "+257",
    flag: "🇧🇮"
  },
  {
    name: "Belgium",
    countryCode2Letter: "BE",
    phoneCode: "+32",
    flag: "🇧🇪"
  },
  {
    name: "Benin",
    countryCode2Letter: "BJ",
    phoneCode: "+229",
    flag: "🇧🇯"
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    countryCode2Letter: "BQ",
    phoneCode: "+599",
    flag: "🇧🇶"
  },
  {
    name: "Burkina Faso",
    countryCode2Letter: "BF",
    phoneCode: "+226",
    flag: "🇧🇫"
  },
  {
    name: "Bangladesh",
    countryCode2Letter: "BD",
    phoneCode: "+880",
    flag: "🇧🇩"
  },
  {
    name: "Bulgaria",
    countryCode2Letter: "BG",
    phoneCode: "+359",
    flag: "🇧🇬"
  },
  {
    name: "Bahrain",
    countryCode2Letter: "BH",
    phoneCode: "+973",
    flag: "🇧🇭"
  },
  {
    name: "Bahamas",
    countryCode2Letter: "BS",
    phoneCode: "+1",
    flag: "🇧🇸"
  },
  {
    name: "Bosnia and Herzegovina",
    countryCode2Letter: "BA",
    phoneCode: "+387",
    flag: "🇧🇦"
  },
  {
    name: "Saint Barthélemy",
    countryCode2Letter: "BL",
    phoneCode: "+590",
    flag: "🇧🇱"
  },
  {
    name: "Belarus",
    countryCode2Letter: "BY",
    phoneCode: "+375",
    flag: "🇧🇾"
  },
  {
    name: "Belize",
    countryCode2Letter: "BZ",
    phoneCode: "+501",
    flag: "🇧🇿"
  },
  {
    name: "Bermuda",
    countryCode2Letter: "BM",
    phoneCode: "+1",
    flag: "🇧🇲"
  },
  {
    name: "Bolivia, Plurinational State of",
    countryCode2Letter: "BO",
    phoneCode: "+591",
    flag: "🇧🇴"
  },
  {
    name: "Brazil",
    countryCode2Letter: "BR",
    phoneCode: "+55",
    flag: "🇧🇷"
  },
  {
    name: "Barbados",
    countryCode2Letter: "BB",
    phoneCode: "+1",
    flag: "🇧🇧"
  },
  {
    name: "Brunei Darussalam",
    countryCode2Letter: "BN",
    phoneCode: "+673",
    flag: "🇧🇳"
  },
  {
    name: "Bhutan",
    countryCode2Letter: "BT",
    phoneCode: "+975",
    flag: "🇧🇹"
  },
  {
    name: "Bouvet Island",
    countryCode2Letter: "BV",
    phoneCode: "+47",
    flag: "🇧🇻"
  },
  {
    name: "Botswana",
    countryCode2Letter: "BW",
    phoneCode: "+267",
    flag: "🇧🇼"
  },
  {
    name: "Central African Republic",
    countryCode2Letter: "CF",
    phoneCode: "+236",
    flag: "🇨🇫"
  },
  {
    name: "Canada",
    countryCode2Letter: "CA",
    phoneCode: "+1",
    flag: "🇨🇦"
  },
  {
    name: "Cocos (Keeling) Islands",
    countryCode2Letter: "CC",
    phoneCode: "+61",
    flag: "🇨🇨"
  },
  {
    name: "Switzerland",
    countryCode2Letter: "CH",
    phoneCode: "+41",
    flag: "🇨🇭"
  },
  {
    name: "Chile",
    countryCode2Letter: "CL",
    phoneCode: "+56",
    flag: "🇨🇱"
  },
  {
    name: "China",
    countryCode2Letter: "CN",
    phoneCode: "+86",
    flag: "🇨🇳"
  },
  {
    name: "Côte d'Ivoire",
    countryCode2Letter: "CI",
    phoneCode: "+225",
    flag: "🇨🇮"
  },
  {
    name: "Cameroon",
    countryCode2Letter: "CM",
    phoneCode: "+237",
    flag: "🇨🇲"
  },
  {
    name: "Congo, the Democratic Republic of the",
    countryCode2Letter: "CD",
    phoneCode: "+243",
    flag: "🇨🇩"
  },
  {
    name: "Congo",
    countryCode2Letter: "CG",
    phoneCode: "+242",
    flag: "🇨🇬"
  },
  {
    name: "Cook Islands",
    countryCode2Letter: "CK",
    phoneCode: "+682",
    flag: "🇨🇰"
  },
  {
    name: "Colombia",
    countryCode2Letter: "CO",
    phoneCode: "+57",
    flag: "🇨🇴"
  },
  {
    name: "Comoros",
    countryCode2Letter: "KM",
    phoneCode: "+269",
    flag: "🇰🇲"
  },
  {
    name: "Cape Verde",
    countryCode2Letter: "CV",
    phoneCode: "+238",
    flag: "🇨🇻"
  },
  {
    name: "Costa Rica",
    countryCode2Letter: "CR",
    phoneCode: "+506",
    flag: "🇨🇷"
  },
  {
    name: "Cuba",
    countryCode2Letter: "CU",
    phoneCode: "+53",
    flag: "🇨🇺"
  },
  {
    name: "Curaçao",
    countryCode2Letter: "CW",
    phoneCode: "+599",
    flag: "🇨🇼"
  },
  {
    name: "Christmas Island",
    countryCode2Letter: "CX",
    phoneCode: "+61",
    flag: "🇨🇽"
  },
  {
    name: "Cayman Islands",
    countryCode2Letter: "KY",
    phoneCode: "+1",
    flag: "🇰🇾"
  },
  {
    name: "Cyprus",
    countryCode2Letter: "CY",
    phoneCode: "+357",
    flag: "🇨🇾"
  },
  {
    name: "Czech Republic",
    countryCode2Letter: "CZ",
    phoneCode: "+420",
    flag: "🇨🇿"
  },
  {
    name: "Germany",
    countryCode2Letter: "DE",
    phoneCode: "+49",
    flag: "🇩🇪"
  },
  {
    name: "Djibouti",
    countryCode2Letter: "DJ",
    phoneCode: "+253",
    flag: "🇩🇯"
  },
  {
    name: "Dominica",
    countryCode2Letter: "DM",
    phoneCode: "+1",
    flag: "🇩🇲"
  },
  {
    name: "Denmark",
    countryCode2Letter: "DK",
    phoneCode: "+45",
    flag: "🇩🇰"
  },
  {
    name: "Dominican Republic",
    countryCode2Letter: "DO",
    phoneCode: "+1",
    flag: "🇩🇴"
  },
  {
    name: "Algeria",
    countryCode2Letter: "DZ",
    phoneCode: "+213",
    flag: "🇩🇿"
  },
  {
    name: "Ecuador",
    countryCode2Letter: "EC",
    phoneCode: "+593",
    flag: "🇪🇨"
  },
  {
    name: "Egypt",
    countryCode2Letter: "EG",
    phoneCode: "+20",
    flag: "🇪🇬"
  },
  {
    name: "Eritrea",
    countryCode2Letter: "ER",
    phoneCode: "+291",
    flag: "🇪🇷"
  },
  {
    name: "Western Sahara",
    countryCode2Letter: "EH",
    phoneCode: "+212",
    flag: "🇪🇭"
  },
  {
    name: "Spain",
    countryCode2Letter: "ES",
    phoneCode: "+34",
    flag: "🇪🇸"
  },
  {
    name: "Estonia",
    countryCode2Letter: "EE",
    phoneCode: "+372",
    flag: "🇪🇪"
  },
  {
    name: "Ethiopia",
    countryCode2Letter: "ET",
    phoneCode: "+251",
    flag: "🇪🇹"
  },
  {
    name: "Finland",
    countryCode2Letter: "FI",
    phoneCode: "+358",
    flag: "🇫🇮"
  },
  {
    name: "Fiji",
    countryCode2Letter: "FJ",
    phoneCode: "+679",
    flag: "🇫🇯"
  },
  {
    name: "Falkland Islands (Malvinas)",
    countryCode2Letter: "FK",
    phoneCode: "+500",
    flag: "🇫🇰"
  },
  {
    name: "France",
    countryCode2Letter: "FR",
    phoneCode: "+33",
    flag: "🇫🇷"
  },
  {
    name: "Faroe Islands",
    countryCode2Letter: "FO",
    phoneCode: "+298",
    flag: "🇫🇴"
  },
  {
    name: "Micronesia, Federated States of",
    countryCode2Letter: "FM",
    phoneCode: "+691",
    flag: "🇫🇲"
  },
  {
    name: "Gabon",
    countryCode2Letter: "GA",
    phoneCode: "+241",
    flag: "🇬🇦"
  },
  {
    name: "United Kingdom",
    countryCode2Letter: "GB",
    phoneCode: "+44",
    flag: "🇬🇧"
  },
  {
    name: "Georgia",
    countryCode2Letter: "GE",
    phoneCode: "+995",
    flag: "🇬🇪"
  },
  {
    name: "Guernsey",
    countryCode2Letter: "GG",
    phoneCode: "+44",
    flag: "🇬🇬"
  },
  {
    name: "Ghana",
    countryCode2Letter: "GH",
    phoneCode: "+233",
    flag: "🇬🇭"
  },
  {
    name: "Gibraltar",
    countryCode2Letter: "GI",
    phoneCode: "+350",
    flag: "🇬🇮"
  },
  {
    name: "Guinea",
    countryCode2Letter: "GN",
    phoneCode: "+224",
    flag: "🇬🇳"
  },
  {
    name: "Guadeloupe",
    countryCode2Letter: "GP",
    phoneCode: "+590",
    flag: "🇬🇵"
  },
  {
    name: "Gambia",
    countryCode2Letter: "GM",
    phoneCode: "+220",
    flag: "🇬🇲"
  },
  {
    name: "Guinea-Bissau",
    countryCode2Letter: "GW",
    phoneCode: "+245",
    flag: "🇬🇼"
  },
  {
    name: "Equatorial Guinea",
    countryCode2Letter: "GQ",
    phoneCode: "+240",
    flag: "🇬🇶"
  },
  {
    name: "Greece",
    countryCode2Letter: "GR",
    phoneCode: "+30",
    flag: "🇬🇷"
  },
  {
    name: "Grenada",
    countryCode2Letter: "GD",
    phoneCode: "+1",
    flag: "🇬🇩"
  },
  {
    name: "Greenland",
    countryCode2Letter: "GL",
    phoneCode: "+299",
    flag: "🇬🇱"
  },
  {
    name: "Guatemala",
    countryCode2Letter: "GT",
    phoneCode: "+502",
    flag: "🇬🇹"
  },
  {
    name: "French Guiana",
    countryCode2Letter: "GF",
    phoneCode: "+594",
    flag: "🇬🇫"
  },
  {
    name: "Guam",
    countryCode2Letter: "GU",
    phoneCode: "+1",
    flag: "🇬🇺"
  },
  {
    name: "Guyana",
    countryCode2Letter: "GY",
    phoneCode: "+592",
    flag: "🇬🇾"
  },
  {
    name: "Hong Kong",
    countryCode2Letter: "HK",
    phoneCode: "+852",
    flag: "🇭🇰"
  },
  {
    name: "Heard Island and McDonald Islands",
    countryCode2Letter: "HM",
    phoneCode: "+672",
    flag: "🇭🇲"
  },
  {
    name: "Honduras",
    countryCode2Letter: "HN",
    phoneCode: "+504",
    flag: "🇭🇳"
  },
  {
    name: "Croatia",
    countryCode2Letter: "HR",
    phoneCode: "+385",
    flag: "🇭🇷"
  },
  {
    name: "Haiti",
    countryCode2Letter: "HT",
    phoneCode: "+509",
    flag: "🇭🇹"
  },
  {
    name: "Hungary",
    countryCode2Letter: "HU",
    phoneCode: "+36",
    flag: "🇭🇺"
  },
  {
    name: "Indonesia",
    countryCode2Letter: "ID",
    phoneCode: "+62",
    flag: "🇮🇩"
  },
  {
    name: "Isle of Man",
    countryCode2Letter: "IM",
    phoneCode: "+44",
    flag: "🇮🇲"
  },
  {
    name: "India",
    countryCode2Letter: "IN",
    phoneCode: "+91",
    flag: "🇮🇳"
  },
  {
    name: "British Indian Ocean Territory",
    countryCode2Letter: "IO",
    phoneCode: "+246",
    flag: "🇮🇴"
  },
  {
    name: "Ireland",
    countryCode2Letter: "IE",
    phoneCode: "+353",
    flag: "🇮🇪"
  },
  {
    name: "Iran, Islamic Republic of",
    countryCode2Letter: "IR",
    phoneCode: "+98",
    flag: "🇮🇷"
  },
  {
    name: "Iraq",
    countryCode2Letter: "IQ",
    phoneCode: "+964",
    flag: "🇮🇶"
  },
  {
    name: "Iceland",
    countryCode2Letter: "IS",
    phoneCode: "+354",
    flag: "🇮🇸"
  },
  {
    name: "Israel",
    countryCode2Letter: "IL",
    phoneCode: "+972",
    flag: "🇮🇱"
  },
  {
    name: "Italy",
    countryCode2Letter: "IT",
    phoneCode: "+39",
    flag: "🇮🇹"
  },
  {
    name: "Jamaica",
    countryCode2Letter: "JM",
    phoneCode: "+1",
    flag: "🇯🇲"
  },
  {
    name: "Jersey",
    countryCode2Letter: "JE",
    phoneCode: "+44",
    flag: "🇯🇪"
  },
  {
    name: "Jordan",
    countryCode2Letter: "JO",
    phoneCode: "+962",
    flag: "🇯🇴"
  },
  {
    name: "Japan",
    countryCode2Letter: "JP",
    phoneCode: "+81",
    flag: "🇯🇵"
  },
  {
    name: "Kazakhstan",
    countryCode2Letter: "KZ",
    phoneCode: "+7",
    flag: "🇰🇿"
  },
  {
    name: "Kenya",
    countryCode2Letter: "KE",
    phoneCode: "+254",
    flag: "🇰🇪"
  },
  {
    name: "Kyrgyzstan",
    countryCode2Letter: "KG",
    phoneCode: "+996",
    flag: "🇰🇬"
  },
  {
    name: "Cambodia",
    countryCode2Letter: "KH",
    phoneCode: "+855",
    flag: "🇰🇭"
  },
  {
    name: "Kiribati",
    countryCode2Letter: "KI",
    phoneCode: "+686",
    flag: "🇰🇮"
  },
  {
    name: "Saint Kitts and Nevis",
    countryCode2Letter: "KN",
    phoneCode: "+1",
    flag: "🇰🇳"
  },
  {
    name: "Korea, Republic of",
    countryCode2Letter: "KR",
    phoneCode: "+82",
    flag: "🇰🇷"
  },
  {
    name: "Kuwait",
    countryCode2Letter: "KW",
    phoneCode: "+965",
    flag: "🇰🇼"
  },
  {
    name: "Lao People's Democratic Republic",
    countryCode2Letter: "LA",
    phoneCode: "+856",
    flag: "🇱🇦"
  },
  {
    name: "Lebanon",
    countryCode2Letter: "LB",
    phoneCode: "+961",
    flag: "🇱🇧"
  },
  {
    name: "Liberia",
    countryCode2Letter: "LR",
    phoneCode: "+231",
    flag: "🇱🇷"
  },
  {
    name: "Libya",
    countryCode2Letter: "LY",
    phoneCode: "+218",
    flag: "🇱🇾"
  },
  {
    name: "Saint Lucia",
    countryCode2Letter: "LC",
    phoneCode: "+1",
    flag: "🇱🇨"
  },
  {
    name: "Liechtenstein",
    countryCode2Letter: "LI",
    phoneCode: "+423",
    flag: "🇱🇮"
  },
  {
    name: "Sri Lanka",
    countryCode2Letter: "LK",
    phoneCode: "+94",
    flag: "🇱🇰"
  },
  {
    name: "Lesotho",
    countryCode2Letter: "LS",
    phoneCode: "+266",
    flag: "🇱🇸"
  },
  {
    name: "Lithuania",
    countryCode2Letter: "LT",
    phoneCode: "+370",
    flag: "🇱🇹"
  },
  {
    name: "Luxembourg",
    countryCode2Letter: "LU",
    phoneCode: "+352",
    flag: "🇱🇺"
  },
  {
    name: "Latvia",
    countryCode2Letter: "LV",
    phoneCode: "+371",
    flag: "🇱🇻"
  },
  {
    name: "Macao",
    countryCode2Letter: "MO",
    phoneCode: "+853",
    flag: "🇲🇴"
  },
  {
    name: "Saint Martin (French part)",
    countryCode2Letter: "MF",
    phoneCode: "+590",
    flag: "🇲🇫"
  },
  {
    name: "Morocco",
    countryCode2Letter: "MA",
    phoneCode: "+212",
    flag: "🇲🇦"
  },
  {
    name: "Monaco",
    countryCode2Letter: "MC",
    phoneCode: "+377",
    flag: "🇲🇨"
  },
  {
    name: "Moldova, Republic of",
    countryCode2Letter: "MD",
    phoneCode: "+373",
    flag: "🇲🇩"
  },
  {
    name: "Madagascar",
    countryCode2Letter: "MG",
    phoneCode: "+261",
    flag: "🇲🇬"
  },
  {
    name: "Maldives",
    countryCode2Letter: "MV",
    phoneCode: "+960",
    flag: "🇲🇻"
  },
  {
    name: "Mexico",
    countryCode2Letter: "MX",
    phoneCode: "+52",
    flag: "🇲🇽"
  },
  {
    name: "Marshall Islands",
    countryCode2Letter: "MH",
    phoneCode: "+692",
    flag: "🇲🇭"
  },
  {
    name: "Macedonia, the Former Yugoslav Republic of",
    countryCode2Letter: "MK",
    phoneCode: "+389",
    flag: "🇲🇰"
  },
  {
    name: "Mali",
    countryCode2Letter: "ML",
    phoneCode: "+223",
    flag: "🇲🇱"
  },
  {
    name: "Malta",
    countryCode2Letter: "MT",
    phoneCode: "+356",
    flag: "🇲🇹"
  },
  {
    name: "Myanmar",
    countryCode2Letter: "MM",
    phoneCode: "+95",
    flag: "🇲🇲"
  },
  {
    name: "Montenegro",
    countryCode2Letter: "ME",
    phoneCode: "+382",
    flag: "🇲🇪"
  },
  {
    name: "Mongolia",
    countryCode2Letter: "MN",
    phoneCode: "+976",
    flag: "🇲🇳"
  },
  {
    name: "Northern Mariana Islands",
    countryCode2Letter: "MP",
    phoneCode: "+1",
    flag: "🇲🇵"
  },
  {
    name: "Mozambique",
    countryCode2Letter: "MZ",
    phoneCode: "+258",
    flag: "🇲🇿"
  },
  {
    name: "Mauritania",
    countryCode2Letter: "MR",
    phoneCode: "+222",
    flag: "🇲🇷"
  },
  {
    name: "Montserrat",
    countryCode2Letter: "MS",
    phoneCode: "+1",
    flag: "🇲🇸"
  },
  {
    name: "Martinique",
    countryCode2Letter: "MQ",
    phoneCode: "+596",
    flag: "🇲🇶"
  },
  {
    name: "Mauritius",
    countryCode2Letter: "MU",
    phoneCode: "+230",
    flag: "🇲🇺"
  },
  {
    name: "Malawi",
    countryCode2Letter: "MW",
    phoneCode: "+265",
    flag: "🇲🇼"
  },
  {
    name: "Malaysia",
    countryCode2Letter: "MY",
    phoneCode: "+60",
    flag: "🇲🇾"
  },
  {
    name: "Mayotte",
    countryCode2Letter: "YT",
    phoneCode: "+262",
    flag: "🇾🇹"
  },
  {
    name: "Namibia",
    countryCode2Letter: "NA",
    phoneCode: "+264",
    flag: "🇳🇦"
  },
  {
    name: "New Caledonia",
    countryCode2Letter: "NC",
    phoneCode: "+687",
    flag: "🇳🇨"
  },
  {
    name: "Niger",
    countryCode2Letter: "NE",
    phoneCode: "+227",
    flag: "🇳🇪"
  },
  {
    name: "Norfolk Island",
    countryCode2Letter: "NF",
    phoneCode: "+672",
    flag: "🇳🇫"
  },
  {
    name: "Nigeria",
    countryCode2Letter: "NG",
    phoneCode: "+234",
    flag: "🇳🇬"
  },
  {
    name: "Nicaragua",
    countryCode2Letter: "NI",
    phoneCode: "+505",
    flag: "🇳🇮"
  },
  {
    name: "Niue",
    countryCode2Letter: "NU",
    phoneCode: "+683",
    flag: "🇳🇺"
  },
  {
    name: "Netherlands",
    countryCode2Letter: "NL",
    phoneCode: "+31",
    flag: "🇳🇱"
  },
  {
    name: "Norway",
    countryCode2Letter: "NO",
    phoneCode: "+47",
    flag: "🇳🇴"
  },
  {
    name: "Nepal",
    countryCode2Letter: "NP",
    phoneCode: "+977",
    flag: "🇳🇵"
  },
  {
    name: "Nauru",
    countryCode2Letter: "NR",
    phoneCode: "+674",
    flag: "🇳🇷"
  },
  {
    name: "New Zealand",
    countryCode2Letter: "NZ",
    phoneCode: "+64",
    flag: "🇳🇿"
  },
  {
    name: "Oman",
    countryCode2Letter: "OM",
    phoneCode: "+968",
    flag: "🇴🇲"
  },
  {
    name: "Pakistan",
    countryCode2Letter: "PK",
    phoneCode: "+92",
    flag: "🇵🇰"
  },
  {
    name: "Panama",
    countryCode2Letter: "PA",
    phoneCode: "+507",
    flag: "🇵🇦"
  },
  {
    name: "Pitcairn",
    countryCode2Letter: "PN",
    phoneCode: "+64",
    flag: "🇵🇳"
  },
  {
    name: "Peru",
    countryCode2Letter: "PE",
    phoneCode: "+51",
    flag: "🇵🇪"
  },
  {
    name: "Philippines",
    countryCode2Letter: "PH",
    phoneCode: "+63",
    flag: "🇵🇭"
  },
  {
    name: "Palau",
    countryCode2Letter: "PW",
    phoneCode: "+680",
    flag: "🇵🇼"
  },
  {
    name: "Papua New Guinea",
    countryCode2Letter: "PG",
    phoneCode: "+675",
    flag: "🇵🇬"
  },
  {
    name: "Poland",
    countryCode2Letter: "PL",
    phoneCode: "+48",
    flag: "🇵🇱"
  },
  {
    name: "Puerto Rico",
    countryCode2Letter: "PR",
    phoneCode: "+1",
    flag: "🇵🇷"
  },
  {
    name: "Korea, Democratic People's Republic of",
    countryCode2Letter: "KP",
    phoneCode: "+850",
    flag: "🇰🇵"
  },
  {
    name: "Portugal",
    countryCode2Letter: "PT",
    phoneCode: "+351",
    flag: "🇵🇹"
  },
  {
    name: "Paraguay",
    countryCode2Letter: "PY",
    phoneCode: "+595",
    flag: "🇵🇾"
  },
  {
    name: "Palestine, State of",
    countryCode2Letter: "PS",
    phoneCode: "+970",
    flag: "🇵🇸"
  },
  {
    name: "French Polynesia",
    countryCode2Letter: "PF",
    phoneCode: "+689",
    flag: "🇵🇫"
  },
  {
    name: "Qatar",
    countryCode2Letter: "QA",
    phoneCode: "+974",
    flag: "🇶🇦"
  },
  {
    name: "Réunion",
    countryCode2Letter: "RE",
    phoneCode: "+262",
    flag: "🇷🇪"
  },
  {
    name: "Romania",
    countryCode2Letter: "RO",
    phoneCode: "+40",
    flag: "🇷🇴"
  },
  {
    name: "Russian Federation",
    countryCode2Letter: "RU",
    phoneCode: "+7",
    flag: "🇷🇺"
  },
  {
    name: "Rwanda",
    countryCode2Letter: "RW",
    phoneCode: "+250",
    flag: "🇷🇼"
  },
  {
    name: "Saudi Arabia",
    countryCode2Letter: "SA",
    phoneCode: "+966",
    flag: "🇸🇦"
  },
  {
    name: "Sudan",
    countryCode2Letter: "SD",
    phoneCode: "+249",
    flag: "🇸🇩"
  },
  {
    name: "Senegal",
    countryCode2Letter: "SN",
    phoneCode: "+221",
    flag: "🇸🇳"
  },
  {
    name: "Singapore",
    countryCode2Letter: "SG",
    phoneCode: "+65",
    flag: "🇸🇬"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    countryCode2Letter: "GS",
    phoneCode: "+500",
    flag: "🇬🇸"
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    countryCode2Letter: "SH",
    phoneCode: "+290",
    flag: "🇸🇭"
  },
  {
    name: "Svalbard and Jan Mayen",
    countryCode2Letter: "SJ",
    phoneCode: "+47",
    flag: "🇸🇯"
  },
  {
    name: "Solomon Islands",
    countryCode2Letter: "SB",
    phoneCode: "+677",
    flag: "🇸🇧"
  },
  {
    name: "Sierra Leone",
    countryCode2Letter: "SL",
    phoneCode: "+232",
    flag: "🇸🇱"
  },
  {
    name: "El Salvador",
    countryCode2Letter: "SV",
    phoneCode: "+503",
    flag: "🇸🇻"
  },
  {
    name: "San Marino",
    countryCode2Letter: "SM",
    phoneCode: "+378",
    flag: "🇸🇲"
  },
  {
    name: "Somalia",
    countryCode2Letter: "SO",
    phoneCode: "+252",
    flag: "🇸🇴"
  },
  {
    name: "Saint Pierre and Miquelon",
    countryCode2Letter: "PM",
    phoneCode: "+508",
    flag: "🇵🇲"
  },
  {
    name: "Serbia",
    countryCode2Letter: "RS",
    phoneCode: "+381",
    flag: "🇷🇸"
  },
  {
    name: "South Sudan",
    countryCode2Letter: "SS",
    phoneCode: "+211",
    flag: "🇸🇸"
  },
  {
    name: "Sao Tome and Principe",
    countryCode2Letter: "ST",
    phoneCode: "+239",
    flag: "🇸🇹"
  },
  {
    name: "Suriname",
    countryCode2Letter: "SR",
    phoneCode: "+597",
    flag: "🇸🇷"
  },
  {
    name: "Slovakia",
    countryCode2Letter: "SK",
    phoneCode: "+421",
    flag: "🇸🇰"
  },
  {
    name: "Slovenia",
    countryCode2Letter: "SI",
    phoneCode: "+386",
    flag: "🇸🇮"
  },
  {
    name: "Sweden",
    countryCode2Letter: "SE",
    phoneCode: "+46",
    flag: "🇸🇪"
  },
  {
    name: "Swaziland",
    countryCode2Letter: "SZ",
    phoneCode: "+268",
    flag: "🇸🇿"
  },
  {
    name: "Sint Maarten (Dutch part)",
    countryCode2Letter: "SX",
    phoneCode: "+1",
    flag: "🇸🇽"
  },
  {
    name: "Seychelles",
    countryCode2Letter: "SC",
    phoneCode: "+248",
    flag: "🇸🇨"
  },
  {
    name: "Syrian Arab Republic",
    countryCode2Letter: "SY",
    phoneCode: "+963",
    flag: "🇸🇾"
  },
  {
    name: "Turks and Caicos Islands",
    countryCode2Letter: "TC",
    phoneCode: "+1",
    flag: "🇹🇨"
  },
  {
    name: "Chad",
    countryCode2Letter: "TD",
    phoneCode: "+235",
    flag: "🇹🇩"
  },
  {
    name: "Togo",
    countryCode2Letter: "TG",
    phoneCode: "+228",
    flag: "🇹🇬"
  },
  {
    name: "Thailand",
    countryCode2Letter: "TH",
    phoneCode: "+66",
    flag: "🇹🇭"
  },
  {
    name: "Tajikistan",
    countryCode2Letter: "TJ",
    phoneCode: "+992",
    flag: "🇹🇯"
  },
  {
    name: "Tokelau",
    countryCode2Letter: "TK",
    phoneCode: "+690",
    flag: "🇹🇰"
  },
  {
    name: "Turkmenistan",
    countryCode2Letter: "TM",
    phoneCode: "+993",
    flag: "🇹🇲"
  },
  {
    name: "Timor-Leste",
    countryCode2Letter: "TL",
    phoneCode: "+670",
    flag: "🇹🇱"
  },
  {
    name: "Tonga",
    countryCode2Letter: "TO",
    phoneCode: "+676",
    flag: "🇹🇴"
  },
  {
    name: "Trinidad and Tobago",
    countryCode2Letter: "TT",
    phoneCode: "+1",
    flag: "🇹🇹"
  },
  {
    name: "Tunisia",
    countryCode2Letter: "TN",
    phoneCode: "+216",
    flag: "🇹🇳"
  },
  {
    name: "Turkey",
    countryCode2Letter: "TR",
    phoneCode: "+90",
    flag: "🇹🇷"
  },
  {
    name: "Tuvalu",
    countryCode2Letter: "TV",
    phoneCode: "+688",
    flag: "🇹🇻"
  },
  {
    name: "Taiwan, Province of China",
    countryCode2Letter: "TW",
    phoneCode: "+886",
    flag: "🇹🇼"
  },
  {
    name: "Tanzania, United Republic of",
    countryCode2Letter: "TZ",
    phoneCode: "+255",
    flag: "🇹🇿"
  },
  {
    name: "Uganda",
    countryCode2Letter: "UG",
    phoneCode: "+256",
    flag: "🇺🇬"
  },
  {
    name: "Ukraine",
    countryCode2Letter: "UA",
    phoneCode: "+380",
    flag: "🇺🇦"
  },
  {
    name: "United States Minor Outlying Islands",
    countryCode2Letter: "UM",
    phoneCode: "+1",
    flag: "🇺🇲"
  },
  {
    name: "Uruguay",
    countryCode2Letter: "UY",
    phoneCode: "+598",
    flag: "🇺🇾"
  },
  {
    name: "Uzbekistan",
    countryCode2Letter: "UZ",
    phoneCode: "+998",
    flag: "🇺🇿"
  },
  {
    name: "Holy See (Vatican City State)",
    countryCode2Letter: "VA",
    phoneCode: "+379",
    flag: "🇻🇦"
  },
  {
    name: "Saint Vincent and the Grenadines",
    countryCode2Letter: "VC",
    phoneCode: "+1",
    flag: "🇻🇨"
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    countryCode2Letter: "VE",
    phoneCode: "+58",
    flag: "🇻🇪"
  },
  {
    name: "Virgin Islands, British",
    countryCode2Letter: "VG",
    phoneCode: "+1",
    flag: "🇻🇬"
  },
  {
    name: "Virgin Islands, U.S.",
    countryCode2Letter: "VI",
    phoneCode: "+1",
    flag: "🇻🇮"
  },
  {
    name: "Viet Nam",
    countryCode2Letter: "VN",
    phoneCode: "+84",
    flag: "🇻🇳"
  },
  {
    name: "Vanuatu",
    countryCode2Letter: "VU",
    phoneCode: "+678",
    flag: "🇻🇺"
  },
  {
    name: "Wallis and Futuna",
    countryCode2Letter: "WF",
    phoneCode: "+681",
    flag: "🇼🇫"
  },
  {
    name: "Samoa",
    countryCode2Letter: "WS",
    phoneCode: "+685",
    flag: "🇼🇸"
  },
  {
    name: "Yemen",
    countryCode2Letter: "YE",
    phoneCode: "+967",
    flag: "🇾🇪"
  },
  {
    name: "South Africa",
    countryCode2Letter: "ZA",
    phoneCode: "+27",
    flag: "🇿🇦"
  },
  {
    name: "Zambia",
    countryCode2Letter: "ZM",
    phoneCode: "+260",
    flag: "🇿🇲"
  },
  {
    name: "Zimbabwe",
    countryCode2Letter: "ZW",
    phoneCode: "+263",
    flag: "🇿🇼"
  }
], zl = /(\+1|1\.|\D)/gim, Hl = (e) => e && Pt(e).replace(zl, ""), gt = (e) => {
  const n = e.replace(/\D/g, "").slice(0, 10), o = "(___) ___-____";
  if (n.length === 0)
    return o;
  let a = "", r = 0;
  for (let i = 0; i < o.length; i++) {
    const c = o[i];
    c === "_" && r < n.length ? (a += n[r], r++) : c === "_" ? a += "_" : a += c;
  }
  return a;
}, rn = (e, n) => e ? n ? /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(e) : /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/.test(e) : void 0, Yt = (e) => e && !rn(e, !0) ? `${Ol}${e}` : e, Gl = (e) => {
  if (e)
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      e
    );
}, jl = Ne((e, n) => {
  const {
    onChange: o = () => {
    },
    value: a,
    error: r,
    label: i = "Email",
    placeholder: c = "example@gmail.com",
    helperText: l
  } = e, m = !!a && !Gl(a), d = (y) => {
    o(typeof y == "string" ? y : y.target.value);
  }, h = r !== void 0 ? r : m;
  return /* @__PURE__ */ t(
    Xe,
    {
      ...e,
      value: a,
      error: h,
      helperText: l || (r === void 0 && h ? "Invalid Email" : ""),
      ref: n,
      type: me.EMAIL,
      onChange: d,
      placeholder: c,
      label: i
    }
  );
}), ql = "_iconButton_t3x40_1", Ul = {
  iconButton: ql
}, Yl = ({
  showPassword: e,
  setShowPassword: n
}) => /* @__PURE__ */ t(ao, { position: "end", children: /* @__PURE__ */ t(
  fe,
  {
    placement: "top",
    title: e ? "Hide Password" : "Show Password",
    children: /* @__PURE__ */ t(
      en,
      {
        "aria-label": e ? "Hide Password" : "Show Password",
        className: Ul.iconButton,
        onClick: () => n(!e),
        children: /* @__PURE__ */ t(
          O,
          {
            icon: e ? ro : io,
            color: "secondary"
          }
        )
      }
    )
  }
) }), Xl = Ne(
  (e, n) => {
    var r;
    const [o, a] = Fe(!1);
    return /* @__PURE__ */ t(
      Xe,
      {
        ...e,
        ref: n,
        endAdornment: /* @__PURE__ */ D(pe, { children: [
          /* @__PURE__ */ t(
            Yl,
            {
              showPassword: o,
              setShowPassword: a
            }
          ),
          (r = e.InputProps) == null ? void 0 : r.endAdornment
        ] }),
        type: o ? me.TEXT : me.PASSWORD
      }
    );
  }
), Zl = "_menuContainer_1vifh_1", Kl = "_countryContainer_1vifh_6", Pl = "_smallContainer_1vifh_15", Vl = "_disabledContainer_1vifh_20", ot = {
  menuContainer: Zl,
  countryContainer: Kl,
  smallContainer: Pl,
  disabledContainer: Vl
}, Jl = Ne(
  ({
    onChange: e,
    value: n,
    label: o,
    country: a,
    setCountry: r,
    size: i,
    id: c,
    disabled: l,
    ...m
  }, d) => {
    const [h, b] = Fe(
      gt(Pt(n))
    ), [y, p] = Fe(
      a || Ut[0]
    ), g = (S) => {
      const $ = S.target.value.replace(/\D/g, ""), N = h.replace(/\D/g, "");
      if ($.length === N.length) {
        const U = N.slice(0, -1), X = gt(U);
        b(X);
        const H = {
          ...S,
          target: { ...S.target, value: U }
        };
        e && e(H);
        return;
      }
      if ($.length > 10)
        return;
      const M = gt($);
      b(M);
      const z = {
        ...S,
        target: { ...S.target, value: Hl($) }
      };
      e && e(z);
    }, f = a || r, v = i === Qe.SMALL;
    return /* @__PURE__ */ D(pe, { children: [
      f && /* @__PURE__ */ t(
        G,
        {
          "data-testid": "phone-input-label",
          component: "label",
          htmlFor: c || "phone-input",
          variant: v ? "captionReg500" : "bodySm500",
          children: o || "Phone number"
        }
      ),
      /* @__PURE__ */ D(W, { alignItems: "center", gap: 0.75, children: [
        f && /* @__PURE__ */ t(
          wt,
          {
            anchorButtonTestId: "country-code-anchor",
            "data-testid": "country-code-menu",
            disabled: l,
            paperClass: ot.menuContainer,
            anchorContent: ({ open: S }) => /* @__PURE__ */ D(
              W,
              {
                className: x(ot.countryContainer, {
                  [ot.smallContainer]: v,
                  [ot.disabledContainer]: l
                }),
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                  /* @__PURE__ */ D(
                    G,
                    {
                      color: l ? "disabledOnDisabledSurface" : void 0,
                      variant: v ? "bodySm400" : "bodyReg400",
                      children: [
                        y.flag,
                        " ",
                        y.phoneCode
                      ]
                    }
                  ),
                  /* @__PURE__ */ t(
                    O,
                    {
                      rotation: S ? 180 : void 0,
                      icon: uo
                    }
                  )
                ]
              }
            ),
            menuProps: {
              selectedId: y.name,
              items: Ut.map((S) => ({
                textContent: () => /* @__PURE__ */ t(W, { alignItems: "center", children: /* @__PURE__ */ D(G, { variant: v ? "bodySm400" : "bodyReg400", children: [
                  S.flag,
                  " ",
                  S.name
                ] }) }),
                id: S.name,
                onClick: () => {
                  r && (r(S), p(S));
                }
              }))
            }
          }
        ),
        /* @__PURE__ */ t(
          Xe,
          {
            ...m,
            disabled: l,
            id: c || "phone-input",
            label: f ? void 0 : o,
            ref: d,
            type: me.PHONE,
            value: h,
            onChange: g,
            size: i
          }
        )
      ] })
    ] });
  }
), Ql = "_searchInputRoot_ny3di_1", ec = "_searchInputLabel_ny3di_6", tc = "_smallSearchInputLabel_ny3di_16", nc = "_shrinkLabel_ny3di_24", oc = "_icon_ny3di_28", ac = "_smallIcon_ny3di_32", Re = {
  searchInputRoot: Ql,
  searchInputLabel: ec,
  smallSearchInputLabel: tc,
  shrinkLabel: nc,
  icon: oc,
  smallIcon: ac
}, rc = Ne((e, n) => {
  const [o, a] = Fe(!1), { floatingLabel: r, label: i, onBlur: c, onFocus: l, onChange: m, size: d, value: h } = e, b = r || i, y = lt(null), p = d === Qe.SMALL, g = /* @__PURE__ */ t(
    O,
    {
      className: x(Re.icon, { [Re.smallIcon]: p }),
      icon: mo
    }
  ), v = /* @__PURE__ */ t(
    en,
    {
      "data-testid": "clear-search-button",
      removePadding: !0,
      onClick: () => {
        if (!m)
          return;
        m({
          target: {
            value: ""
          }
        });
      },
      children: /* @__PURE__ */ t(
        O,
        {
          className: x(Re.icon, { [Re.smallIcon]: p }),
          icon: Zt
        }
      )
    }
  );
  return Lt(() => {
    var S, B, $, N, M, z, U, X;
    if (i) {
      (M = y == null ? void 0 : y.current) == null || M.setAttribute(
        "size",
        String(((N = ($ = (B = (S = y == null ? void 0 : y.current) == null ? void 0 : S.labels) == null ? void 0 : B[0]) == null ? void 0 : $.textContent) == null ? void 0 : N.length) ?? "")
      );
      return;
    }
    (X = y == null ? void 0 : y.current) == null || X.setAttribute(
      "size",
      String(((U = (z = y.current) == null ? void 0 : z.getAttribute("placeholder")) == null ? void 0 : U.length) ?? "")
    );
  }, [i]), /* @__PURE__ */ t(
    Xe,
    {
      "data-testid": "search-input",
      inputRef: y,
      ref: n,
      startAdornment: g,
      endAdornment: h ? v : void 0,
      useFloatingLabel: !0,
      inputRootClass: Re.searchInputRoot,
      InputLabelProps: {
        shrink: !!h || o,
        classes: {
          root: x({
            [Re.searchInputLabel]: !o && !h,
            [Re.smallSearchInputLabel]: p
          }),
          shrink: Re.shrinkLabel
        }
      },
      onBlur: (S) => {
        a(!1), c == null || c(S);
      },
      onFocus: (S) => {
        a(!0), l == null || l(S);
      },
      ...e,
      label: o || h ? b : i
    }
  );
}), ic = Ne((e, n) => {
  const {
    error: o,
    helperText: a,
    label: r = "URL",
    onChange: i = () => {
    },
    placeholder: c = "https://",
    value: l
  } = e, m = (p) => {
    i(typeof p == "string" ? p : p.target.value);
  }, d = (p) => {
    i(Yt(p.currentTarget.value));
  }, h = (p) => {
    p.key === "Enter" && i(Yt(p.currentTarget.value));
  }, b = !!l && !rn(l, !1) || o;
  return /* @__PURE__ */ t(
    Xe,
    {
      ...e,
      label: r,
      placeholder: c,
      onBlur: d,
      onChange: m,
      onKeyUp: h,
      error: b,
      helperText: a || (b ? "Invalid URL format" : ""),
      ref: n,
      type: me.URL,
      value: l
    }
  );
}), ms = Ne((e, n) => {
  const { type: o } = e;
  switch (o) {
    case me.PASSWORD:
      return /* @__PURE__ */ t(Xl, { ref: n, ...e });
    case me.SEARCH:
      return /* @__PURE__ */ t(rc, { ref: n, ...e });
    case me.PHONE:
      return /* @__PURE__ */ t(Jl, { ref: n, ...e });
    case me.URL:
      return /* @__PURE__ */ t(ic, { ref: n, ...e });
    case me.EMAIL:
      return /* @__PURE__ */ t(jl, { ref: n, ...e });
    default:
      return /* @__PURE__ */ t(Xe, { ref: n, ...e });
  }
}), lc = "_blueHover_1dzzk_6", cc = "_underline_1dzzk_10", Xt = {
  blueHover: lc,
  underline: cc
}, dc = (e) => {
  const {
    href: n = "#",
    color: o = "blueXtraDark",
    children: a,
    className: r = "",
    forceUnderline: i = !1,
    forceDisableNewTab: c = !1
  } = e, l = Ge(n) ? "a" : et, m = { [Ge(n) ? "href" : "to"]: n };
  return /* @__PURE__ */ t(
    G,
    {
      color: o,
      className: x("textLink", r, {
        [Xt.blueHover]: o === "blueXtraDark",
        [Xt.underline]: i
      }),
      component: l,
      target: c ? "_self" : "_blank",
      rel: c ? void 0 : "noreferrer",
      ...e,
      ...m,
      children: a
    }
  );
}, sc = "_labelLeft_1v65u_5", uc = "_label_1v65u_5", mc = "_labelTop_1v65u_14", fc = "_switchThumb_1v65u_22", gc = "_switchTrack_1v65u_26", hc = "_switchChecked_1v65u_32", pc = "_root_1v65u_37", Cc = "_small_1v65u_37", bc = "_switchBase_1v65u_66", yc = "_switchDisabled_1v65u_70", _c = "_description_1v65u_92", Lc = "_medium_1v65u_96", Sc = "_switchContainer_1v65u_97", ie = {
  labelLeft: sc,
  label: uc,
  labelTop: mc,
  switchThumb: fc,
  switchTrack: gc,
  switch: "_switch_1v65u_22",
  switchChecked: hc,
  root: pc,
  small: Cc,
  switchBase: bc,
  switchDisabled: yc,
  description: _c,
  medium: Lc,
  switchContainer: Sc
};
var ln = /* @__PURE__ */ ((e) => (e.Right = "right", e.Top = "top", e.Left = "left", e))(ln || {}), cn = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(cn || {});
const fs = ({
  size: e = cn.Medium,
  labelDirection: n = ln.Right,
  name: o,
  checked: a,
  disabled: r,
  onChange: i,
  value: c,
  label: l,
  "data-testid": m,
  description: d,
  "aria-label": h,
  containerClass: b = "",
  classes: y,
  inputProps: p,
  ...g
}) => {
  const f = e === "small", v = e === "medium", S = f ? "captionReg500" : "bodyReg500", B = f ? "captionSm500" : "bodySm400", $ = l || d;
  return /* @__PURE__ */ D(
    W,
    {
      alignItems: "start",
      columnGap: 1,
      rowGap: 1,
      className: x(ie.root, b, {
        [ie.small]: f,
        [ie.medium]: v,
        [ie.labelLeft]: n === "left" && l,
        [ie.labelTop]: n === "top" && l
      }),
      children: [
        /* @__PURE__ */ t(W, { alignItems: "center", className: ie.switchContainer, children: /* @__PURE__ */ t(
          lo,
          {
            id: o,
            name: o,
            size: e,
            value: c,
            checked: a,
            disabled: r,
            onChange: i,
            classes: {
              root: ie.switch,
              thumb: ie.switchThumb,
              track: ie.switchTrack,
              checked: ie.switchChecked,
              switchBase: ie.switchBase,
              disabled: ie.switchDisabled,
              ...y
            },
            inputProps: {
              // data-testid not part of Mui inputProps
              // @ts-ignore
              "data-testid": m,
              ...h ? { "aria-label": h } : {},
              ...p
            },
            ...g
          }
        ) }),
        $ && /* @__PURE__ */ D(W, { flexDirection: "column", children: [
          l && /* @__PURE__ */ t(
            G,
            {
              className: ie.label,
              variant: S,
              component: "label",
              htmlFor: o,
              children: l
            }
          ),
          d && /* @__PURE__ */ t(
            G,
            {
              className: ie.description,
              variant: B,
              component: "label",
              htmlFor: o,
              children: d
            }
          )
        ] })
      ]
    }
  );
}, xc = "_paper_10qwm_1", vc = "_popoverPaper_10qwm_9", wc = "_menuPaper_10qwm_13", kc = "_popoverContainer_10qwm_21", Dc = "_menuIconRight_10qwm_25", Fc = "_arrow_10qwm_30", Mc = "_arrowBottom_10qwm_41", $c = "_arrowTop_10qwm_48", Ic = "_arrowLeft_10qwm_55", Bc = "_arrowRight_10qwm_62", Rc = "_anchorButton_10qwm_68", Tc = "_bottom_10qwm_75", Ac = "_top_10qwm_76", Wc = "_left_10qwm_80", Nc = "_right_10qwm_81", Ec = "_noArrow_10qwm_85", Oc = "_hoverable_10qwm_90", zc = "_disabled_10qwm_91", le = {
  paper: xc,
  popoverPaper: vc,
  menuPaper: wc,
  popoverContainer: kc,
  menuIconRight: Dc,
  arrow: Fc,
  arrowBottom: Mc,
  arrowTop: $c,
  arrowLeft: Ic,
  arrowRight: Bc,
  anchorButton: Rc,
  bottom: Tc,
  top: Ac,
  left: Wc,
  right: Nc,
  noArrow: Ec,
  hoverable: Oc,
  disabled: zc
}, Hc = "_root_156cw_1", Gc = "_disabled_156cw_5", jc = "_textContent_156cw_24", qc = "_menuIconRight_156cw_28", Uc = "_wrapper_156cw_33", Ze = {
  root: Hc,
  disabled: Gc,
  textContent: jc,
  menuIconRight: qc,
  wrapper: Uc
}, Yc = ({
  children: e,
  href: n = "",
  className: o,
  disabled: a = !1
}) => {
  if (!n || a)
    return /* @__PURE__ */ t("span", { className: o, children: e });
  const r = (i) => {
    i.preventDefault();
  };
  return Ge(n) ? /* @__PURE__ */ t(
    "a",
    {
      className: o,
      href: n,
      rel: "noreferrer noopener",
      target: "_blank",
      onClick: r,
      children: e
    }
  ) : /* @__PURE__ */ t(et, { onClick: r, className: o, to: n, children: e });
}, Xc = We.forwardRef(
  ({
    item: e,
    index: n,
    menuClasses: o,
    menuProps: a,
    handleClose: r,
    ...i
  }) => {
    const c = Rn(), l = lt(null), { selectedId: m, items: d, withDivider: h } = a || {}, {
      textContent: b,
      onClick: y = () => {
      },
      iconLeft: p,
      iconRight: g,
      tooltipProps: f,
      disabled: v = !1,
      id: S,
      href: B
    } = e || {}, $ = m && S && m === S, N = g !== !1 && (g || $ || f), M = (d == null ? void 0 : d.length) || 0, z = n < M - 1 && h, U = () => g === !1 ? null : g || ($ ? /* @__PURE__ */ t(O, { icon: so, "data-testid": "selected-check" }) : f ? /* @__PURE__ */ t(O, { icon: co }) : null), { title: X = "", placement: H = "right" } = f || {}, R = (ce) => {
      v || (ce.preventDefault(), ce.stopPropagation(), r(), y(S || n), B && setTimeout(() => {
        Ge(B) ? window.open(B, "_blank", "noopener noreferrer") : c(B);
      }, 10));
    }, I = () => b ? typeof b == "string" ? /* @__PURE__ */ t(
      G,
      {
        color: v ? "disabledDefault" : "default",
        variant: (a == null ? void 0 : a.textVariant) || "bodySm500",
        className: Ze.textContent,
        noWrap: !0,
        children: b
      }
    ) : b({ onClose: r }) : null;
    return Lt(() => {
      !$ || !(l != null && l.current) || l == null || l.current.scrollIntoView({
        block: "center"
      });
    }, [$]), /* @__PURE__ */ D(pe, { children: [
      /* @__PURE__ */ t(
        fe,
        {
          title: X,
          placement: H,
          ...f,
          children: /* @__PURE__ */ t(
            Cn,
            {
              ref: l,
              ...i,
              classes: {
                root: x(Ze.root, o == null ? void 0 : o.item, { [Ze.disabled]: v })
              },
              onClick: R,
              "data-testid": `menu-item-${S || n}`,
              children: /* @__PURE__ */ D(Yc, { href: B, disabled: v, className: Ze.wrapper, children: [
                p && /* @__PURE__ */ t(
                  $t,
                  {
                    classes: {
                      root: o == null ? void 0 : o.iconLeft
                    },
                    children: p
                  }
                ),
                I(),
                N && /* @__PURE__ */ t(
                  $t,
                  {
                    classes: {
                      root: x(Ze.menuIconRight, o == null ? void 0 : o.iconRight)
                    },
                    children: U()
                  }
                )
              ] })
            }
          )
        },
        (a == null ? void 0 : a.selectedId) || n
      ),
      z && /* @__PURE__ */ t(bn, { "data-testid": "divider", component: "li" })
    ] });
  }
), wt = ({
  anchorButtonClass: e,
  anchorButtonTestId: n = "popover-anchor-button",
  anchorContent: o = () => /* @__PURE__ */ t("button", { type: "button", children: "Anchor" }),
  "aria-label": a,
  disabled: r = !1,
  disabledMessage: i = "Disabled",
  hideArrow: c = !1,
  hoverable: l = !1,
  messagePlacement: m = "top",
  onAnchorClick: d = () => null,
  onCloseCallback: h = () => null,
  paperClass: b,
  placement: y = "bottom",
  popoverContent: p = () => /* @__PURE__ */ t("div", {}),
  tooltipProps: g,
  menuProps: f,
  menuClasses: v,
  withCustomAnchor: S,
  wrapperClass: B,
  ...$
}) => {
  const [N, M] = Fe(null), z = lt(null), U = f ? yn : _n, X = {
    bottom: {
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      transformOrigin: { vertical: "top", horizontal: "center" }
    },
    top: {
      anchorOrigin: { vertical: "top", horizontal: "center" },
      transformOrigin: { vertical: "bottom", horizontal: "center" }
    },
    left: {
      anchorOrigin: { vertical: "center", horizontal: "left" },
      transformOrigin: { vertical: "center", horizontal: "right" }
    },
    right: {
      anchorOrigin: { vertical: "center", horizontal: "right" },
      transformOrigin: { vertical: "center", horizontal: "left" }
    }
  }, H = (C) => {
    d(), M(N ? null : C.currentTarget);
  }, R = () => {
    M(null), h();
  }, I = (C) => {
    l && M(C.currentTarget);
  }, ce = () => {
    l && (M(null), h());
  }, Le = () => !r && !(g != null && g.title) ? "" : (g == null ? void 0 : g.title) || i, k = !!N, _ = {
    "aria-expanded": k,
    "aria-label": a,
    "aria-owns": l && k ? "mouse-over-popover" : void 0,
    "aria-haspopup": "true",
    "data-testid": n,
    disabled: r,
    type: "button",
    onClick: H,
    onMouseEnter: I,
    onMouseLeave: ce,
    className: x(
      le.anchorButton,
      le[y],
      {
        [le.hoverable]: l,
        [le.noArrow]: c,
        [le.disabled]: r
      },
      e
    )
  };
  return /* @__PURE__ */ D(pe, { children: [
    /* @__PURE__ */ t(
      fe,
      {
        title: Le(),
        placement: m,
        ...g,
        children: S ? o({ disabled: r, open: k, anchorElementProps: _ }) : /* @__PURE__ */ t("button", { ..._, children: o({ disabled: r, open: k, anchorElementProps: _ }) })
      }
    ),
    /* @__PURE__ */ t(
      U,
      {
        sx: l ? { pointerEvents: "none" } : void 0,
        ...X[y],
        ...$,
        id: l ? "mouse-over-popover" : void 0,
        open: k,
        anchorEl: N,
        anchorReference: "anchorEl",
        onClose: R,
        disableRestoreFocus: l,
        disableEnforceFocus: l,
        classes: {
          root: B,
          paper: x(le.paper, b, {
            [le.popoverPaper]: !f,
            [le.menuPaper]: f
          })
        },
        children: Array.isArray(f == null ? void 0 : f.items) ? f.items.map((C, w) => /* @__PURE__ */ t(
          Xc,
          {
            item: C,
            index: w,
            menuClasses: v,
            menuProps: f,
            handleClose: R
          },
          C.id || w
        )) : /* @__PURE__ */ D("div", { className: le.popoverContainer, children: [
          !c && /* @__PURE__ */ t(
            "span",
            {
              ref: z,
              className: x(le.arrow, {
                [le.arrowBottom]: y === "bottom",
                [le.arrowTop]: y === "top",
                [le.arrowLeft]: y === "left",
                [le.arrowRight]: y === "right"
              })
            }
          ),
          p({ setAnchor: M })
        ] })
      }
    )
  ] });
};
export {
  Qd as Avatar,
  Ye as Badge,
  rt as Button,
  ns as Calendar,
  xt as Card,
  cr as CardCap,
  Rr as Checkbox,
  Jt as ClickableComponent,
  os as Divider,
  W as Flexbox,
  O as FontAwesomeIcon,
  en as IconButton,
  rr as InfoNote,
  as as LoadingOverlay,
  rs as MuiThemeProvider,
  is as ProgressBar,
  ls as SegmentedControl,
  cs as Skeleton,
  ds as StatusLozenge,
  ss as StatusVisualizationFilter,
  Cl as Tab,
  us as Tabs,
  G as Text,
  ms as TextInput,
  dc as TextLink,
  fs as Toggle,
  fe as Tooltip,
  wt as WithPopover,
  es as camelCase,
  s as cssVars,
  Pt as ensureString,
  ts as generateCssVarsPlugin,
  po as kebabCase,
  Ro as theme,
  St as useMediaInfo
};
